module.exports = {
	"swagger": "2.0",
	"info": {
		"version": "v1",
		"title": "NewformaLink V1"
	},
	"host": "huntington",
	"basePath": "/NewformaLink",
	"schemes": [
		"http"
	],
	"paths": {
		"/actionitems": {
			"get": {
				"tags": [
					"ActionItems"
				],
				"summary": "Gets the open action items associated with the current user across all projects in their My Projects list.",
				"description": "Default is to return action items assigned to the current user.",
				"operationId": "ActionItems_GetOpenActionItems",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "to",
						"in": "query",
						"description": "Set to \"me\" to get action items assigned TO the current user.\r\n            If {by} is also set to \"me\", the meaning is: items assigned either to me OR by me.",
						"required": false,
						"type": "string"
					},
					{
						"name": "by",
						"in": "query",
						"description": "Set to \"me\" to get action items assigned BY the current user.\r\n            If {to} is also set to \"me\", the meaning is: items assigned either to me OR by me.",
						"required": false,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "Open action items, in no particular order, assigned to the authenticated user across all projects hosted on this NPCS server.",
						"schema": {
							"$ref": "#/definitions/ActionItemListDTO"
						}
					},
					"400": {
						"description": "Use 'to=me' and/or 'by=me' query parameters."
					}
				}
			},
			"options": {
				"tags": [
					"ActionItems"
				],
				"summary": "Gets list of HTTP verbs permitted by the current user in the response header 'Allow'.",
				"operationId": "ActionItems_ActionItemsOptions",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"responses": {
					"204": {
						"description": "List of HTTP verbs permitted by the current user in the response header 'Allow'."
					}
				}
			}
		},
		"/actionitems/filter": {
			"post": {
				"tags": [
					"ActionItems"
				],
				"summary": "Gets a list of open action items that correspond to the filter.",
				"description": "When the filter is empty, action items assigned to the current user across all projects in their My Projects list is returned.",
				"operationId": "ActionItems_FilterActionItems",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "filter",
						"in": "body",
						"description": "Allows action items to be filtered.",
						"required": true,
						"schema": {
							"$ref": "#/definitions/ActionItemsFilterRequestDto"
						}
					}
				],
				"responses": {
					"200": {
						"description": "The request has been successfully processed.",
						"schema": {
							"$ref": "#/definitions/ActionItemListDTO"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/actionitems": {
			"get": {
				"tags": [
					"ActionItems"
				],
				"summary": "Gets the open action items in the specified project.",
				"description": "Default is to return all open action items in the project regardless of who they are assigned to or by.",
				"operationId": "ActionItems_GetOpenActionItemsByProject",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "to",
						"in": "query",
						"description": "Set to \"me\" to get action items assigned TO the current user.\r\n            If {by} is also set to \"me\", the meaning is: items assigned either to me OR by me.",
						"required": false,
						"type": "string"
					},
					{
						"name": "by",
						"in": "query",
						"description": "Set to \"me\" to get action items assigned BY the current user.\r\n            If {to} is also set to \"me\", the meaning is: items assigned either to me OR by me.",
						"required": false,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "Open action items, in no particular order, in the specified project.",
						"schema": {
							"$ref": "#/definitions/ActionItemListDTO"
						}
					},
					"400": {
						"description": "Use 'to=me' and/or 'by=me' query parameters."
					}
				}
			},
			"post": {
				"tags": [
					"ActionItems"
				],
				"summary": "Creates an action item.",
				"operationId": "ActionItems_CreateActionItem",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project in which to create the item",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "actionItem",
						"in": "body",
						"description": "The properties of the action item to create",
						"required": true,
						"schema": {
							"$ref": "#/definitions/NascentActionItemDTO"
						}
					}
				],
				"responses": {
					"201": {
						"description": "Add an action item to a specified project, returning its ID.",
						"schema": {
							"$ref": "#/definitions/CreateActionItemResponse"
						}
					},
					"403": {
						"description": "Permission to create action items in the specified project is required."
					},
					"404": {
						"description": "The specified project is not available."
					}
				}
			},
			"options": {
				"tags": [
					"ActionItems"
				],
				"summary": "Gets list of HTTP verbs permitted by the current user in the response header 'Allow'.",
				"operationId": "ActionItems_ProjectActionItemsOptions",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string",
						"format": "uuid"
					}
				],
				"responses": {
					"204": {
						"description": "List of HTTP verbs permitted by the current user in the response header 'Allow'."
					}
				}
			}
		},
		"/projects/{projectId}/actionitems/{actionItemId}": {
			"get": {
				"tags": [
					"ActionItems"
				],
				"summary": "Gets a specified action item.",
				"operationId": "ActionItems_GetActionItemDetail",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project that contains the action item",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "actionItemId",
						"in": "path",
						"description": "The action item's GUID",
						"required": true,
						"type": "string",
						"format": "uuid"
					}
				],
				"responses": {
					"200": {
						"description": "An action item given its ID and its project's ID.",
						"schema": {
							"$ref": "#/definitions/ActionItemDetailDTO"
						}
					},
					"404": {
						"description": "The specified action item is not available in the specified project or the project is not available."
					}
				}
			},
			"put": {
				"tags": [
					"ActionItems"
				],
				"summary": "Updates an action item.",
				"operationId": "ActionItems_UpdateActionItem",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project that contains the action item",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "actionItemId",
						"in": "path",
						"description": "The action item's GUID",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "actionItem",
						"in": "body",
						"description": "The details of the action item",
						"required": true,
						"schema": {
							"$ref": "#/definitions/UpdatedActionItemDTO"
						}
					}
				],
				"responses": {
					"204": {
						"description": "The action item was updated"
					},
					"400": {
						"description": "The action item detail does not match the given project id or action item id."
					},
					"403": {
						"description": "Permission to update action items in the specified project is required."
					},
					"404": {
						"description": "The specified action item is not available in the specified project or the project is not available."
					},
					"409": {
						"description": "The action item could not be updated because it had already been modified."
					}
				}
			},
			"delete": {
				"tags": [
					"ActionItems"
				],
				"summary": "Deletes an action item.",
				"operationId": "ActionItems_DeleteActionItem",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project that contains the action item",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "actionItemId",
						"in": "path",
						"description": "The action item's GUID",
						"required": true,
						"type": "string",
						"format": "uuid"
					}
				],
				"responses": {
					"204": {
						"description": "The action item was deleted"
					},
					"403": {
						"description": "Permission to delete action items in the specified project is required."
					},
					"404": {
						"description": "The specified action item is not available in the specified project or the project is not available."
					}
				}
			},
			"options": {
				"tags": [
					"ActionItems"
				],
				"summary": "Gets list of HTTP verbs permitted by the current user in the response header 'Allow'.",
				"operationId": "ActionItems_ProjectActionItemOptions",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "actionItemId",
						"in": "path",
						"required": true,
						"type": "string",
						"format": "uuid"
					}
				],
				"responses": {
					"204": {
						"description": "List of HTTP verbs permitted by the current user in the response header 'Allow'."
					}
				}
			}
		},
		"/projects/{projectId}/actionitems/{actionItemId}/supportingdocuments": {
			"put": {
				"tags": [
					"ActionItems"
				],
				"summary": "Links single supporting document to an action item.",
				"operationId": "ActionItems_LinkSupportingDocument",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project that contains the action item",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "actionItemId",
						"in": "path",
						"description": "The action item's GUID",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "projectFolderId",
						"in": "query",
						"description": "Root project folder id",
						"required": true,
						"type": "integer",
						"format": "int64"
					},
					{
						"name": "folderPath",
						"in": "query",
						"description": "Path to folder where file is located",
						"required": true,
						"type": "string"
					},
					{
						"name": "fileName",
						"in": "query",
						"description": "File name that will be unlinked",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "The supporting document was linked to action item."
					},
					"400": {
						"description": "The arguments specified are not valid."
					},
					"403": {
						"description": "Permission to link supporting document to action item in the specified project is required."
					},
					"404": {
						"description": "The specified action item is not available in the specified project."
					},
					"409": {
						"description": "The supporting document is already linked to action item."
					}
				}
			},
			"delete": {
				"tags": [
					"ActionItems"
				],
				"summary": "Unlinks single supporting document to an action item.",
				"operationId": "ActionItems_UnlinkSupportingDocument",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project that contains the action item",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "actionItemId",
						"in": "path",
						"description": "The action item's GUID",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "projectFolderId",
						"in": "query",
						"description": "Root project folder id",
						"required": true,
						"type": "integer",
						"format": "int64"
					},
					{
						"name": "folderPath",
						"in": "query",
						"description": "Path to folder where file is located",
						"required": true,
						"type": "string"
					},
					{
						"name": "fileName",
						"in": "query",
						"description": "File name that will be unlinked",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "The supporting document was unlinked from action item."
					},
					"400": {
						"description": "The arguments specified are not valid."
					},
					"403": {
						"description": "Permission to unlink supporting document to action item in the specified project is required."
					},
					"404": {
						"description": "The specified action item is not available in the specified project, file does not exist or wasn't linked."
					}
				}
			},
			"patch": {
				"tags": [
					"ActionItems"
				],
				"summary": "Processes batch of operations on Action Item Supporting Documents. Currently supported operations are linking (add) and unlinking (remove). Because of current performance limitations there might be maximum 20 operations in batch.",
				"operationId": "ActionItems_BatchUpdateSupportingDocuments",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project that contains the action item",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "actionItemId",
						"in": "path",
						"description": "The action item's GUID",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "operations",
						"in": "body",
						"description": "Operations on supporting documents (add for linking, remove for unlinking). Maximum count of 20 is allowed.",
						"required": true,
						"schema": {
							"type": "array",
							"items": {
								"$ref": "#/definitions/BatchOperation"
							}
						}
					}
				],
				"responses": {
					"200": {
						"description": "All supporting documents operations succeeded"
					},
					"207": {
						"description": "At least one supporting documents operation succeeded and at least one failed."
					},
					"400": {
						"description": "The arguments specified are not valid."
					},
					"403": {
						"description": "Permission to link or unlink supporting documents to action item in the specified project is required."
					},
					"404": {
						"description": "The specified action item is not available in the specified project or file does not exist."
					},
					"409": {
						"description": "At least one of the linking operation was performed on already linked supporting document."
					}
				}
			}
		},
		"/projects/{projectId}/actionitems/{actionItemId}/discussionitems": {
			"get": {
				"tags": [
					"ActionItems"
				],
				"summary": "Gets the discussion items associated with a specified action item.",
				"operationId": "ActionItems_GetDiscussionItems",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project that contains the action item",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "actionItemId",
						"in": "path",
						"description": "The action item's GUID",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "The discussion items ordered by date with most recent first.",
						"schema": {
							"$ref": "#/definitions/PagedResponseDto[DiscussionItem]"
						}
					},
					"400": {
						"description": "The arguments specified are not valid."
					},
					"404": {
						"description": "The specified action item is not available in the specified project or the project is not available."
					}
				}
			},
			"post": {
				"tags": [
					"ActionItems"
				],
				"summary": "Adds the discussion item provided in the POST body.",
				"operationId": "ActionItems_CreateDiscussionItem",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project that contains the action item",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "actionItemId",
						"in": "path",
						"description": "The action item's GUID",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "discussionItem",
						"in": "body",
						"description": "The Discussion Item to be added",
						"required": true,
						"schema": {
							"$ref": "#/definitions/NascentDiscussionItemDto"
						}
					}
				],
				"responses": {
					"201": {
						"description": "Add a discussion item to a specified action item, returning its ID."
					},
					"400": {
						"description": "The arguments specified are not valid."
					},
					"401": {
						"description": "The user has not been authenticated."
					},
					"403": {
						"description": "The user does not have permission to create a Discussion Item for this Action Item."
					},
					"404": {
						"description": "The specified project or action item is not available."
					}
				}
			}
		},
		"/projects/{projectId}/actionitems/{actionItemId}/discussionitems/{discussionItemId}": {
			"delete": {
				"tags": [
					"ActionItems"
				],
				"summary": "Deletes the discussion item",
				"operationId": "ActionItems_DeleteDiscussionItem",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project that contains the action item",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "actionItemId",
						"in": "path",
						"description": "The action item's GUID",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "discussionItemId",
						"in": "path",
						"description": "The Discussion Item to be deleted",
						"required": true,
						"type": "integer",
						"format": "int64"
					}
				],
				"responses": {
					"204": {
						"description": "The discussion item has been deleted."
					},
					"400": {
						"description": "The arguments specified are not valid."
					},
					"401": {
						"description": "The user has not been authenticated."
					},
					"403": {
						"description": "The user does not have permission to delete this Discussion Item."
					},
					"404": {
						"description": "The specified project, action item, or discussion Item is not available."
					}
				}
			},
			"patch": {
				"tags": [
					"ActionItems"
				],
				"summary": "Updates the discussion item with the values provided in the PATCH body.",
				"operationId": "ActionItems_UpdateDiscussionItem",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project that contains the action item",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "actionItemId",
						"in": "path",
						"description": "The action item's GUID",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "discussionItemId",
						"in": "path",
						"description": "The Discussion Item's ID",
						"required": true,
						"type": "integer",
						"format": "int64"
					},
					{
						"name": "discussionItem",
						"in": "body",
						"description": "The Discussion Item to be modified",
						"required": true,
						"schema": {
							"$ref": "#/definitions/NascentDiscussionItemDto"
						}
					}
				],
				"responses": {
					"204": {
						"description": "The Discussion Item has been modified"
					},
					"400": {
						"description": "The arguments specified are not valid."
					},
					"401": {
						"description": "The user has not been authenticated."
					},
					"403": {
						"description": "You do not have permission to edit this Discussion Item"
					},
					"404": {
						"description": "The specified project, action item, or discussion Item is not available."
					}
				}
			}
		},
		"/companies/self": {
			"get": {
				"tags": [
					"Companies"
				],
				"summary": "Gets the company associated to the current server.",
				"operationId": "Companies_GetCurrentCompany",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"responses": {
					"200": {
						"description": "The request has been successfully processed.",
						"schema": {
							"$ref": "#/definitions/CompanySelfDto"
						}
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/contracts": {
			"get": {
				"tags": [
					"Contracts"
				],
				"summary": "Gets the Contracts in the specified project.",
				"description": "Default is to return all Contracts in the project regardless of the status.",
				"operationId": "Contracts_GetContractsList",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "List of Contracts for the specified project.",
						"schema": {
							"$ref": "#/definitions/PagedResponseDto[ContractDTO]"
						}
					},
					"400": {
						"description": "Invalid offset token is provided."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/folders/{projectFolderId}/content": {
			"get": {
				"tags": [
					"Files"
				],
				"operationId": "Files_DownloadFile",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "projectFolderId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "fileName",
						"in": "query",
						"required": true,
						"type": "string"
					},
					{
						"name": "folderPath",
						"in": "query",
						"required": false,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "The file content as a stream of bytes."
					},
					"202": {
						"description": "EDMS file is downloading from source."
					},
					"206": {
						"description": "Partial response when the request included a byte range."
					},
					"400": {
						"description": "Bad request."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"416": {
						"description": "The range of data requested from the resource cannot be returned."
					},
					"500": {
						"description": "Internal server error."
					},
					"501": {
						"description": "EDMS file download is not implemented."
					}
				}
			}
		},
		"/projects/{projectId}/folders/{projectFolderId}": {
			"delete": {
				"tags": [
					"Files"
				],
				"operationId": "Files_DeleteFile",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "projectFolderId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "fileName",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "folderPath",
						"in": "query",
						"required": false,
						"type": "string"
					}
				],
				"responses": {
					"204": {
						"description": "The file deleted."
					},
					"400": {
						"description": "Bad request."
					},
					"403": {
						"description": "The user does not have permissions"
					},
					"404": {
						"description": "This resource does not exist."
					},
					"405": {
						"description": "The file does not support being deleted."
					},
					"409": {
						"description": "The file was not deleted."
					},
					"500": {
						"description": "Internal server error."
					},
					"501": {
						"description": "EDMS file delete is not implemented."
					}
				}
			},
			"patch": {
				"tags": [
					"Files"
				],
				"operationId": "Files_RenameFile",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "projectFolderId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "body",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/FolderPatchBody"
						}
					},
					{
						"name": "folderPath",
						"in": "query",
						"required": true,
						"type": "string"
					},
					{
						"name": "fileName",
						"in": "query",
						"required": false,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "The file was updated."
					},
					"400": {
						"description": "Bad request."
					},
					"403": {
						"description": "The user does not have permissions"
					},
					"404": {
						"description": "This resource does not exist."
					},
					"409": {
						"description": "A file already exists with the requested name."
					},
					"500": {
						"description": "Internal server error."
					},
					"501": {
						"description": "EDMS file rename is not implemented."
					}
				}
			}
		},
		"/projects/{projectId}/folders/{projectFolder}/uploadSessions": {
			"post": {
				"tags": [
					"FileUpload"
				],
				"summary": "Initiates file upload session to selected folder located in specific project and project folder.",
				"operationId": "FileUpload_CreateUploadSession",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Project Id",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectFolder",
						"in": "path",
						"description": "Project folder id can be passed or special folder type in format `special_{type}`. Currently only `special_fieldnotes` is supported.",
						"required": true,
						"type": "string"
					},
					{
						"name": "request",
						"in": "body",
						"description": "Upload parameters",
						"required": true,
						"schema": {
							"$ref": "#/definitions/CreateFileUploadSessionRequest"
						}
					}
				],
				"responses": {
					"200": {
						"description": "The request has been successfully processed.",
						"schema": {
							"$ref": "#/definitions/FileUploadSessionResource"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "Project or project folder does not exist."
					},
					"409": {
						"description": "Selected file already exist and allowOverwrite parameter in request was set to false."
					},
					"412": {
						"description": "Selected project folder does not contain folder with selected relative path (specified by folder parts)."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/folders/{projectFolder}/uploadSessions/{sessionId}": {
			"delete": {
				"tags": [
					"FileUpload"
				],
				"summary": "Deletes upload session. This endpoint should be used when the upload process failed to not leave phantom upload sessions.",
				"operationId": "FileUpload_DeleteUploadSession",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Project Id",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectFolder",
						"in": "path",
						"description": "Project folder id can be passed or special folder type in format `special_{type}`. Currently only `special_fieldnotes` is supported.",
						"required": true,
						"type": "string"
					},
					{
						"name": "sessionId",
						"in": "path",
						"description": "Session Id",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"204": {
						"description": "The request has been successfully processed."
					},
					"400": {
						"description": "Bad request."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "Upload session does not exist or project id, projectFolder route parameters do not match session values."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			},
			"patch": {
				"tags": [
					"FileUpload"
				],
				"summary": "Updates upload session information (status, relative download path and region). To finish upload pass - `UploadComplete` status.",
				"operationId": "FileUpload_PatchUploadSession",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Project Id",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectFolder",
						"in": "path",
						"description": "Project folder id can be passed or special folder type in format `special_{type}`. Currently only `special_fieldnotes` is supported.",
						"required": true,
						"type": "string"
					},
					{
						"name": "sessionId",
						"in": "path",
						"description": "Session Id",
						"required": true,
						"type": "string"
					},
					{
						"name": "request",
						"in": "body",
						"description": "Upload parameters",
						"required": true,
						"schema": {
							"$ref": "#/definitions/PatchFileUploadSessionRequest"
						}
					}
				],
				"responses": {
					"200": {
						"description": "The request has been successfully processed.",
						"schema": {
							"$ref": "#/definitions/FileUploadSessionResource"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "Upload session does not exist or project id, projectFolder route parameters do not match session values."
					},
					"409": {
						"description": "Unsuccessful try to complete already completed session."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/folders/{projectFolderId}/folderContents": {
			"post": {
				"tags": [
					"Folders"
				],
				"operationId": "Folders_GetFolderContents",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectFolderId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "requestBody",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/FolderContentsRequestBody"
						}
					}
				],
				"responses": {
					"200": {
						"description": "The folder contents.",
						"schema": {
							"$ref": "#/definitions/FolderContentsResponse"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/folders/{projectFolderId}/folders": {
			"post": {
				"tags": [
					"Folders"
				],
				"operationId": "Folders_CreateNewFolder",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectFolderId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "requestBody",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/CreateFolderRequest"
						}
					}
				],
				"responses": {
					"200": {
						"description": "The newly created folder.",
						"schema": {
							"$ref": "#/definitions/Folder"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"403": {
						"description": "The user does not have permissions"
					},
					"404": {
						"description": "This resource does not exist."
					},
					"409": {
						"description": "A folder with the given name already exists."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/health": {
			"get": {
				"tags": [
					"Health"
				],
				"operationId": "Health_GetHealth",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"responses": {
					"200": {
						"description": "Result code telling you whether or not the system is healthy."
					}
				}
			}
		},
		"/projects/{projectId}/keywords": {
			"get": {
				"tags": [
					"Keywords"
				],
				"summary": "Gets keywords within a specific project.",
				"operationId": "Keywords_GetKeywords",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Project Id",
						"required": true,
						"type": "string"
					},
					{
						"name": "listType",
						"in": "query",
						"description": "Filters the result to include only items from a specific list type.",
						"required": true,
						"type": "string",
						"enum": [
							"action_item_type",
							"discussion_actions",
							"submittal_discipline_list",
							"submittal_keyword_list",
							"submittal_specsection_list",
							"submittal_action_list",
							"rfi_action_list",
							"rfi_reasons_list",
							"rfi_discipline_list",
							"rfi_keyword_list",
							"rfi_types_list",
							"transfer_methods_list"
						]
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					},
					{
						"name": "query",
						"in": "query",
						"description": "Used to filter keywords by name and description",
						"required": false,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "The request has been successfully processed.",
						"schema": {
							"$ref": "#/definitions/KeywordsFilterResponseDto"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/keywords": {
			"get": {
				"tags": [
					"Keywords"
				],
				"summary": "Gets keywords across all projects.",
				"operationId": "Keywords_GetAllKeywords",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "listType",
						"in": "query",
						"description": "Filters the result to include only items from a specific list type.",
						"required": true,
						"type": "string",
						"enum": [
							"action_item_type",
							"discussion_actions",
							"submittal_discipline_list",
							"submittal_keyword_list",
							"submittal_specsection_list"
						]
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					},
					{
						"name": "query",
						"in": "query",
						"description": "Used to filter keywords by name and description",
						"required": false,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "The request has been successfully processed.",
						"schema": {
							"$ref": "#/definitions/AllKeywordsFilterResponseDto"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/submittals/{submittalId}/workflowactions/{actionType}/keywords": {
			"get": {
				"tags": [
					"Keywords"
				],
				"summary": "Gets Submittals action keywords for purpose and response",
				"operationId": "Keywords_GetSubmittalActionKeywords",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Project Id",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "submittalId",
						"in": "path",
						"description": "Submittal Id",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "actionType",
						"in": "path",
						"description": "Type of submittal action",
						"required": true,
						"type": "string"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					},
					{
						"name": "query",
						"in": "query",
						"description": "Used to filter keywords by name and description",
						"required": false,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "The request has been successfully processed.",
						"schema": {
							"$ref": "#/definitions/WorkflowActionKeywordsResponseDTO"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/submittals/workflowactions/{actionType}/keywords": {
			"get": {
				"tags": [
					"Keywords"
				],
				"summary": "Gets Submittals action keywords for purpose and response",
				"operationId": "Keywords_GetSubmittalActionKeywords",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Project Id",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "actionType",
						"in": "path",
						"description": "Type of workflow action",
						"required": true,
						"type": "string",
						"enum": [
							"log",
							"receive",
							"forward",
							"receivePendingReviewerResponse",
							"recordReviewerResponse",
							"respondAndClose",
							"close"
						]
					},
					{
						"name": "submittalId",
						"in": "query",
						"description": "Submittal Id for `Receive Pending Reviewer Response` action keywords",
						"required": false,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					},
					{
						"name": "query",
						"in": "query",
						"description": "Used to filter keywords by name and description",
						"required": false,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "The request has been successfully processed.",
						"schema": {
							"$ref": "#/definitions/WorkflowActionKeywordsResponseDTO"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/rfis/workflowactions/{actionType}/keywords": {
			"get": {
				"tags": [
					"Keywords"
				],
				"summary": "Gets RFIs action keywords for purpose and response",
				"operationId": "Keywords_GetRfiActionKeywords",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Project Id",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "actionType",
						"in": "path",
						"description": "Type of workflow action",
						"required": true,
						"type": "string",
						"enum": [
							"log",
							"receive",
							"forward",
							"receivePendingReviewerResponse",
							"recordReviewerResponse",
							"respondAndClose",
							"close"
						]
					},
					{
						"name": "rfiId",
						"in": "query",
						"description": "RFI Id for `Receive Pending Reviewer Response` action keywords",
						"required": false,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					},
					{
						"name": "query",
						"in": "query",
						"description": "Used to filter keywords by name and description",
						"required": false,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "The request has been successfully processed.",
						"schema": {
							"$ref": "#/definitions/WorkflowActionKeywordsResponseDTO"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/permissions": {
			"post": {
				"tags": [
					"Permissions"
				],
				"operationId": "Permissions_Permissions",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "request",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/PermissionsRequest"
						}
					}
				],
				"responses": {
					"200": {
						"description": "The request has been successfully processed.",
						"schema": {
							"$ref": "#/definitions/PermissionsResponse"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/email/preview": {
			"get": {
				"tags": [
					"ProjectEmail"
				],
				"summary": "Gets a specified project email.",
				"operationId": "ProjectEmail_GetProjectEmailPreview",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project that contains the project email",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "path",
						"in": "query",
						"description": "The base64-encoded JSON-string of the path-array to the project email file",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "A project email given its file name and path and its project's ID.",
						"schema": {
							"$ref": "#/definitions/EmailPreviewResponse"
						}
					},
					"202": {
						"description": "EDMS file is downloading from source."
					},
					"400": {
						"description": "Bad request."
					},
					"404": {
						"description": "The specified project email is not available in the specified project."
					}
				}
			},
			"options": {
				"tags": [
					"ProjectEmail"
				],
				"summary": "Gets list of HTTP verbs permitted by the current user in the response header 'Allow'.",
				"operationId": "ProjectEmail_ProjectEmailOptions",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project that contains the project email",
						"required": true,
						"type": "string",
						"format": "uuid"
					}
				],
				"responses": {
					"204": {
						"description": "List of HTTP verbs permitted by the current user in the response header 'Allow'."
					}
				}
			}
		},
		"/projects/global": {
			"get": {
				"tags": [
					"Projects"
				],
				"summary": "Retrieves all projects available for the user.",
				"operationId": "Projects_GetAllProjectsPaged",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "excludeMyProjects",
						"in": "query",
						"required": false,
						"type": "boolean"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "All projects available for the user.",
						"schema": {
							"$ref": "#/definitions/PagedResponseDto[Project]"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal server error.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			}
		},
		"/projects": {
			"get": {
				"tags": [
					"Projects"
				],
				"summary": "Retrieves the NPC My Projects list for a contact.",
				"operationId": "Projects_GetMyProjects",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "filter",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "uacCheck",
						"in": "query",
						"required": false,
						"type": "boolean"
					}
				],
				"responses": {
					"200": {
						"description": "The current user's NPC My Projects list.",
						"schema": {
							"$ref": "#/definitions/ProjectsResponse"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal server error.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			}
		},
		"/projects/{projectId}": {
			"get": {
				"tags": [
					"Projects"
				],
				"operationId": "Projects_GetProject",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "Details about the requested project",
						"schema": {
							"$ref": "#/definitions/ProjectDetails"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			}
		},
		"/projects/{projectId}/projectFolders": {
			"get": {
				"tags": [
					"Projects"
				],
				"operationId": "Projects_GetProjectFolders",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "List of project folders",
						"schema": {
							"$ref": "#/definitions/ProjectFoldersResponse"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			}
		},
		"/projects/{projectId}/settings": {
			"get": {
				"tags": [
					"Projects"
				],
				"operationId": "Projects_GetProjectSettings",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string",
						"format": "uuid"
					}
				],
				"responses": {
					"200": {
						"description": "Project settings",
						"schema": {
							"$ref": "#/definitions/ProjectSettings"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/projectteam": {
			"get": {
				"tags": [
					"ProjectTeam"
				],
				"operationId": "ProjectTeam_FilterProjectTeam",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					},
					{
						"name": "query",
						"in": "query",
						"required": false,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/FilterResponseDto[ProjectTeamItemDto]"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/teammembers": {
			"get": {
				"tags": [
					"ProjectTeamMembers"
				],
				"operationId": "ProjectTeamMembers_FilterProjectTeamMembers",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "source.sourcePrimaryKey",
						"in": "query",
						"description": "The identifier of data object in the third-party system. May be any string or serialized object as defined by the third-party system.",
						"required": false,
						"type": "string"
					},
					{
						"name": "source.sourceDescriptor",
						"in": "query",
						"description": "A short descriptive (human-readable) name of the third-party system or subsystem.",
						"required": false,
						"type": "string"
					},
					{
						"name": "lastModifiedUtc",
						"in": "query",
						"required": false,
						"type": "DateTime",
						"format": "DateTime"
					},
					{
						"name": "groupIds",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/FilterResponseDto[ProjectTeamMemberRefDto]"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"post": {
				"tags": [
					"ProjectTeamMembers"
				],
				"operationId": "ProjectTeamMembers_Create",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectTeamMemberCreateRequestDto",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/ProjectTeamMemberCreateRequestDto"
						}
					}
				],
				"responses": {
					"201": {
						"description": "Created",
						"schema": {
							"$ref": "#/definitions/CreateResponseDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"409": {
						"description": "Conflict"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/teammembers/{projectTeamMemberId}": {
			"get": {
				"tags": [
					"ProjectTeamMembers"
				],
				"operationId": "ProjectTeamMembers_GetProjectTeamMemberById",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectTeamMemberId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/ProjectTeamMemberDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"put": {
				"tags": [
					"ProjectTeamMembers"
				],
				"operationId": "ProjectTeamMembers_Update",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectTeamMemberId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectTeamMemberUpdateDto",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/ProjectTeamMemberUpdateRequestDto"
						}
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"delete": {
				"tags": [
					"ProjectTeamMembers"
				],
				"operationId": "ProjectTeamMembers_Delete",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectTeamMemberId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/rfis": {
			"get": {
				"tags": [
					"Rfis"
				],
				"summary": "Gets the RFI in the specified project.",
				"description": "Default is to return all open RFIs in the project regardless of the status. For the grouped response only pending, open and forwarded for review RFI are returned.",
				"operationId": "Rfis_GetRfiList",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "groupBy",
						"in": "query",
						"description": "`GroupBy` parameter defining the shape of the response (flat if not defined and grouped by statuses if `status` value is passed)",
						"required": false,
						"type": "string",
						"enum": [
							"None",
							"Status"
						]
					},
					{
						"name": "status",
						"in": "query",
						"description": "`Status` parameter allows filtering flat list of RFI based on their status",
						"required": false,
						"type": "string",
						"enum": [
							"none",
							"open"
						]
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "RFIs grouped by statuses ordered descending by due date, in the specified project.",
						"schema": {
							"$ref": "#/definitions/RfisGroupingResponse"
						}
					},
					"400": {
						"description": "Invalid RFI grouping (`groupBy` parameter with value different than `status` or `none`) or invalid offset token are provided.",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "The requested resource requires authentication.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "This resource does not exist.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal server error.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			}
		},
		"/projects/{projectId}/rfis/{rfiId}": {
			"get": {
				"tags": [
					"Rfis"
				],
				"summary": "Gets details of a RFI",
				"operationId": "Rfis_GetRFI",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "rfiId",
						"in": "path",
						"description": "The GUID of the RFI",
						"required": true,
						"type": "string",
						"format": "uuid"
					}
				],
				"responses": {
					"200": {
						"description": "Details about the requested RFI",
						"schema": {
							"$ref": "#/definitions/RFIDetailsDto"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/rfis/log": {
			"post": {
				"tags": [
					"Rfis"
				],
				"summary": "Creates new received RFI",
				"operationId": "Rfis_LogRFI",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "request",
						"in": "body",
						"description": "Parameters for received RFi",
						"required": true,
						"schema": {
							"$ref": "#/definitions/RfiLogRequestDTO"
						}
					}
				],
				"responses": {
					"200": {
						"description": "Log a received RFI.",
						"schema": {
							"$ref": "#/definitions/WorkflowActionQueuedResponseDto"
						}
					},
					"204": {
						"description": "Log a received RFI."
					},
					"400": {
						"description": "Bad request.",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "The requested resource requires authentication.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "This resource does not exist.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"409": {
						"description": "Conflict occurred while updating the resource.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal server error.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			},
			"delete": {
				"tags": [
					"Rfis"
				],
				"summary": "Delete temp folder for workflow",
				"operationId": "Rfis_DeleteTempFilesForLogAction",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "deleteFolderPartsRequest",
						"in": "body",
						"description": "Data to access temp folder",
						"required": true,
						"schema": {
							"$ref": "#/definitions/DeleteFolderPartsRequestDTO"
						}
					},
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"type": "object"
						}
					},
					"204": {
						"description": "Cleaned after workflow action"
					},
					"400": {
						"description": "Bad request.",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "The requested resource requires authentication.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "This resource does not exist.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal server error.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			},
			"patch": {
				"tags": [
					"Rfis"
				],
				"summary": "Completes log a RFI if all files were downloaded.\r\nOtherwise does nothing and awaits further.",
				"description": "Validates if RFI version is correct prior to any other operation.",
				"operationId": "Rfis_CompleteLogRFI",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "request",
						"in": "body",
						"description": "Forward action parameters to complete the action",
						"required": true,
						"schema": {
							"$ref": "#/definitions/RfiCompleteLogRequestDTO"
						}
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"type": "object"
						}
					},
					"202": {
						"description": "Not all files are downloaded, retry after delay"
					},
					"204": {
						"description": "Action has been invoked"
					},
					"400": {
						"description": "Bad request.",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "The requested resource requires authentication.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "This resource does not exist.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"409": {
						"description": "Conflict occurred while updating the resource.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal server error.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			}
		},
		"/projects/{projectId}/rfis/{rfiId}/reviewresponse": {
			"put": {
				"tags": [
					"Rfis"
				],
				"summary": "Create submit review response workflow action for a RFI\r\nCreate lock on RFI to indicate in progress state where new files where included.",
				"description": "Validates if RFI version is correct prior to any other operation.",
				"operationId": "Rfis_SubmitResponseRFI",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "rfiId",
						"in": "path",
						"description": "Thhe GUID of the RFI",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "request",
						"in": "body",
						"description": "Forward action parameters",
						"required": true,
						"schema": {
							"$ref": "#/definitions/RfiSubmitResponseRequestDTO"
						}
					}
				],
				"responses": {
					"200": {
						"description": "Forward action has been initiated and awaits all files to be available."
					},
					"204": {
						"description": "Forward action for RFI has been executed."
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"409": {
						"description": "Conflict occurred while updating the resource."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			},
			"patch": {
				"tags": [
					"Rfis"
				],
				"summary": "Completes submit review response workflow action for a RFI\r\nOtherwise does nothing and awaits further.",
				"description": "Validates if RFI version is correct prior to any other operation.",
				"operationId": "Rfis_CompleteSubmitResponseRfi",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "rfiId",
						"in": "path",
						"description": "Thhe GUID of the RFI",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "request",
						"in": "body",
						"description": "Forward action parameters to complete the action",
						"required": true,
						"schema": {
							"$ref": "#/definitions/RfiCompleteSubmitResponseRequestDTO"
						}
					}
				],
				"responses": {
					"200": {
						"description": "Not all files are downloaded, retry after delay"
					},
					"204": {
						"description": "Forward action has been invoked"
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"409": {
						"description": "Conflict occurred while updating the resource."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/rfis/{rfiId}/workflowAction": {
			"delete": {
				"tags": [
					"Rfis"
				],
				"summary": "Remove lock for project item and delete temp folder for workflow",
				"operationId": "Rfis_CleanAfterWorkflowAction",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "rfiId",
						"in": "path",
						"description": "Thhe GUID of the RFI",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "deleteWorkflowActionRequest",
						"in": "body",
						"description": "Data to access temp folder and project item lock",
						"required": true,
						"schema": {
							"$ref": "#/definitions/DeleteWorkflowActionRequestDTO"
						}
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"type": "object"
						}
					},
					"204": {
						"description": "Cleaned after workflow action"
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/submittals": {
			"get": {
				"tags": [
					"Submittals"
				],
				"summary": "Gets the submittals in the specified project.",
				"description": "Default is to return all open submittals in the project regardless of the status. For the grouped response only pending, open and forwarded for review submittals are returned.",
				"operationId": "Submittals_GetSubmittalsList",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "groupBy",
						"in": "query",
						"description": "`GroupBy` parameter defining the shape of the response (flat if not defined and grouped by statuses if `status` value is passed)",
						"required": false,
						"type": "string",
						"enum": [
							"None",
							"Status"
						]
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "Submittals grouped by statuses ordered descending by due date, in the specified project.",
						"schema": {
							"$ref": "#/definitions/SubmittalsGroupingResponse"
						}
					},
					"400": {
						"description": "Invalid submmittals grouping (`groupBy` parameter with value different than `status` or `none`) or invalid offset token are provided."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/submittals/{submittalId}": {
			"get": {
				"tags": [
					"Submittals"
				],
				"summary": "Gets details of a submittal",
				"operationId": "Submittals_GetSubmittal",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "submittalId",
						"in": "path",
						"description": "The GUID of the submittal",
						"required": true,
						"type": "string",
						"format": "uuid"
					}
				],
				"responses": {
					"200": {
						"description": "Details about the requested submittal",
						"schema": {
							"$ref": "#/definitions/SubmittalDetailsDto"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			},
			"patch": {
				"tags": [
					"Submittals"
				],
				"summary": "Updates the submittals details.",
				"description": "Validates if submittal version is correct prior to any other operation.",
				"operationId": "Submittals_UpdateSubmittalDetails",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "submittalId",
						"in": "path",
						"description": "Thhe GUID of the submittal",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "details",
						"in": "body",
						"description": "Update values for submittal.",
						"required": true,
						"schema": {
							"$ref": "#/definitions/SubmittalUpdatedDetailsDto"
						}
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"type": "object"
						}
					},
					"204": {
						"description": "Submittal details have been updated."
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"409": {
						"description": "Conflict occurred while updating the resource."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/submittals/{submittalId}/files": {
			"get": {
				"tags": [
					"Submittals"
				],
				"summary": "Gets submittal associated files with additional information about workflow action they originated from",
				"description": "List of assosiated files if ordered by workflow action (oldest first) and then by file name alphabetically.",
				"operationId": "Submittals_GetFileSummary",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "submittalId",
						"in": "path",
						"description": "The GUID of the submittal",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "Submittal's file summary",
						"schema": {
							"$ref": "#/definitions/PagedResponseDto[WorkflowActionFileDto]"
						}
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/submittals/{submittalId}/workflowActions": {
			"get": {
				"tags": [
					"Submittals"
				],
				"summary": "Gets the Workflow Actions for the specified submittal.",
				"description": "List of Workflow Actions",
				"operationId": "Submittals_GetSubmittalWorkflowActions",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "submittalId",
						"in": "path",
						"description": "The GUID of the submittal",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "Workflow actions list ordered descending by action date, for the specified submittal.",
						"schema": {
							"$ref": "#/definitions/SubmittalInfoAndActions"
						}
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/submittals/{submittalId}/forward": {
			"put": {
				"tags": [
					"Submittals"
				],
				"summary": "Creates forward workflow action for a submittal if all files are from previous actions or no files where attached.\r\nCreate lock on submittal to indicate in progress state where new files where included.",
				"description": "Validates if submittal version is correct prior to any other operation.",
				"operationId": "Submittals_ForwardSubmittal",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "submittalId",
						"in": "path",
						"description": "Thhe GUID of the submittal",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "request",
						"in": "body",
						"description": "Forward action parameters",
						"required": true,
						"schema": {
							"$ref": "#/definitions/SubmittalForwardRequestDTO"
						}
					}
				],
				"responses": {
					"200": {
						"description": "Forward action has been initiated and awaits all files to be available."
					},
					"204": {
						"description": "Forward action for submittal has been executed."
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"409": {
						"description": "Conflict occurred while updating the resource."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			},
			"patch": {
				"tags": [
					"Submittals"
				],
				"summary": "Completes forward action for submittal if all files were downloaded.\r\nOtherwise does nothing and awaits further.",
				"description": "Validates if submittal version is correct prior to any other operation.",
				"operationId": "Submittals_CompleteSubmittalForward",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "submittalId",
						"in": "path",
						"description": "Thhe GUID of the submittal",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "request",
						"in": "body",
						"description": "Forward action parameters to complete the action",
						"required": true,
						"schema": {
							"$ref": "#/definitions/SubmittalCompleteForwardRequestDTO"
						}
					}
				],
				"responses": {
					"200": {
						"description": "Not all files are downloaded, retry after delay"
					},
					"204": {
						"description": "Forward action has been invoked"
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"409": {
						"description": "Conflict occurred while updating the resource."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/submittals/{submittalId}/receive": {
			"put": {
				"tags": [
					"Submittals"
				],
				"summary": "Create receive workflow action for a submittal",
				"description": "Validates if submittal version is correct prior to any other operation.",
				"operationId": "Submittals_ReceiveSubmittal",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "submittalId",
						"in": "path",
						"description": "Thhe GUID of the submittal",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "request",
						"in": "body",
						"description": "Receive action parameters",
						"required": true,
						"schema": {
							"$ref": "#/definitions/SubmittalReceiveRequestDTO"
						}
					}
				],
				"responses": {
					"200": {
						"description": "Receive action for a submittal have been performed."
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"409": {
						"description": "Conflict occurred while updating the resource."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			},
			"patch": {
				"tags": [
					"Submittals"
				],
				"summary": "Completes receive action for submittal if all files were downloaded.\r\nOtherwise does nothing and awaits further.",
				"description": "Validates if submittal version is correct prior to any other operation.",
				"operationId": "Submittals_CompleteSubmittalReceive",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "submittalId",
						"in": "path",
						"description": "Thhe GUID of the submittal",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "request",
						"in": "body",
						"description": "Receive action parameters to complete the action",
						"required": true,
						"schema": {
							"$ref": "#/definitions/SubmittalCompleteReceiveRequestDTO"
						}
					}
				],
				"responses": {
					"200": {
						"description": "Not all files are downloaded, retry after delay"
					},
					"204": {
						"description": "Receive action has been invoked"
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"409": {
						"description": "Conflict occurred while updating the resource."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/submittals/{submittalId}/workflowAction": {
			"delete": {
				"tags": [
					"Submittals"
				],
				"summary": "Remove lock for project item and delete temp folder for workflow",
				"operationId": "Submittals_CleanAfterWorkflowAction",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "submittalId",
						"in": "path",
						"description": "Thhe GUID of the submittal",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "deleteWorkflowActionRequest",
						"in": "body",
						"description": "Data to access temp folder and project item lock",
						"required": true,
						"schema": {
							"$ref": "#/definitions/DeleteWorkflowActionRequestDTO"
						}
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"type": "object"
						}
					},
					"204": {
						"description": "Cleaned after workflow action"
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/submittals/log": {
			"post": {
				"tags": [
					"Submittals"
				],
				"summary": "Creates new received submittal",
				"operationId": "Submittals_LogSubmittal",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "request",
						"in": "body",
						"description": "Parameters for received submittal",
						"required": true,
						"schema": {
							"$ref": "#/definitions/SubmittalLogRequestDTO"
						}
					}
				],
				"responses": {
					"200": {
						"description": "Log a received submittal."
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"409": {
						"description": "Conflict occurred while updating the resource."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			},
			"delete": {
				"tags": [
					"Submittals"
				],
				"summary": "Delete temp folder for workflow",
				"operationId": "Submittals_DeleteTempFilesForLogAction",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "deleteFolderPartsRequest",
						"in": "body",
						"description": "Data to access temp folder",
						"required": true,
						"schema": {
							"$ref": "#/definitions/DeleteFolderPartsRequestDTO"
						}
					},
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"type": "object"
						}
					},
					"204": {
						"description": "Cleaned after workflow action"
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			},
			"patch": {
				"tags": [
					"Submittals"
				],
				"summary": "Completes log a submittal if all files were downloaded.\r\nOtherwise does nothing and awaits further.",
				"description": "Validates if submittal version is correct prior to any other operation.",
				"operationId": "Submittals_CompleteLogSubmittal",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "request",
						"in": "body",
						"description": "Forward action parameters to complete the action",
						"required": true,
						"schema": {
							"$ref": "#/definitions/SubmittalCompleteLogRequestDTO"
						}
					}
				],
				"responses": {
					"200": {
						"description": "Not all files are downloaded, retry after delay"
					},
					"204": {
						"description": "Action has been invoked"
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"409": {
						"description": "Conflict occurred while updating the resource."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/projects/{projectId}/submittals/{submittalId}/reviewresponse": {
			"put": {
				"tags": [
					"Submittals"
				],
				"summary": "Create submit review response workflow action for a submittal\r\nCreate lock on submittal to indicate in progress state where new files where included.",
				"description": "Validates if submittal version is correct prior to any other operation.",
				"operationId": "Submittals_SubmitResponseSubmittal",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "submittalId",
						"in": "path",
						"description": "Thhe GUID of the submittal",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "request",
						"in": "body",
						"description": "Forward action parameters",
						"required": true,
						"schema": {
							"$ref": "#/definitions/SubmittalSubmitResponseRequestDTO"
						}
					}
				],
				"responses": {
					"200": {
						"description": "Forward action has been initiated and awaits all files to be available."
					},
					"204": {
						"description": "Forward action for submittal has been executed."
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"409": {
						"description": "Conflict occurred while updating the resource."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			},
			"patch": {
				"tags": [
					"Submittals"
				],
				"summary": "Completes submit review response workflow action for a submittal\r\nOtherwise does nothing and awaits further.",
				"description": "Validates if submittal version is correct prior to any other operation.",
				"operationId": "Submittals_CompleteSubmitResponseSubmittal",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The GUID of the project",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "submittalId",
						"in": "path",
						"description": "Thhe GUID of the submittal",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "request",
						"in": "body",
						"description": "Forward action parameters to complete the action",
						"required": true,
						"schema": {
							"$ref": "#/definitions/SubmittalCompleteSubmitResponseRequestDTO"
						}
					}
				],
				"responses": {
					"200": {
						"description": "Not all files are downloaded, retry after delay"
					},
					"204": {
						"description": "Forward action has been invoked"
					},
					"400": {
						"description": "Bad request."
					},
					"401": {
						"description": "The requested resource requires authentication."
					},
					"403": {
						"description": "User is not licensed for Project Center."
					},
					"404": {
						"description": "This resource does not exist."
					},
					"409": {
						"description": "Conflict occurred while updating the resource."
					},
					"500": {
						"description": "Internal server error."
					}
				}
			}
		},
		"/me": {
			"get": {
				"tags": [
					"User"
				],
				"summary": "Retrieves contact information about the current Project Center user.",
				"operationId": "User_GetCurrentContact",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"responses": {
					"200": {
						"description": "The current user's NPC contact information.",
						"schema": {
							"$ref": "#/definitions/ContactDTO"
						}
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			}
		},
		"/search": {
			"post": {
				"tags": [
					"Search"
				],
				"operationId": "V1Search_Get",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "requestDto",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/V1SearchRequestDto"
						}
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/PagedResponseDto[SearchResponseDto]"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/version": {
			"get": {
				"tags": [
					"Version"
				],
				"summary": "Gets version information about this server.",
				"operationId": "Version_GetVersionInfo",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"responses": {
					"200": {
						"description": "Version information",
						"schema": {
							"$ref": "#/definitions/NewformaVersionInfo"
						}
					},
					"404": {
						"description": "Installation is corrupt."
					}
				}
			}
		}
	},
	"definitions": {
		"CancellationToken": {
			"type": "object",
			"properties": {
				"IsCancellationRequested": {
					"type": "boolean",
					"readOnly": true
				},
				"CanBeCanceled": {
					"type": "boolean",
					"readOnly": true
				},
				"WaitHandle": {
					"$ref": "#/definitions/WaitHandle",
					"readOnly": true
				}
			}
		},
		"WaitHandle": {
			"type": "object",
			"properties": {
				"Handle": {
					"type": "object"
				},
				"SafeWaitHandle": {
					"$ref": "#/definitions/SafeWaitHandle"
				}
			}
		},
		"SafeWaitHandle": {
			"type": "object",
			"properties": {
				"IsInvalid": {
					"type": "boolean",
					"readOnly": true
				},
				"IsClosed": {
					"type": "boolean",
					"readOnly": true
				}
			}
		},
		"ActionItemListDTO": {
			"description": "List of Action Items",
			"required": [
				"data"
			],
			"type": "object",
			"properties": {
				"data": {
					"description": "The list of Action Items.",
					"type": "array",
					"items": {
						"$ref": "#/definitions/ActionItemDTO"
					}
				}
			}
		},
		"ActionItemDTO": {
			"description": "An Action Item as contained with a list of Action Items",
			"required": [
				"subject"
			],
			"type": "object",
			"properties": {
				"id": {
					"format": "uuid",
					"description": "Unique ID (Guid)",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"projectId": {
					"format": "uuid",
					"description": "Unique ID (Guid) of the project this Action Item belongs to",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"assignedTo": {
					"description": "List of contacts this item is assigned to",
					"type": "array",
					"items": {
						"$ref": "#/definitions/ContactDTO"
					}
				},
				"assignedBy": {
					"$ref": "#/definitions/ContactDTO",
					"description": "Contact information about who assigned this item"
				},
				"projectName": {
					"description": "Name of the project this Action Item belongs to",
					"type": "string"
				},
				"projectNumber": {
					"description": "Number of the project this Action Item belongs to",
					"type": "string"
				},
				"creationDate": {
					"format": "DateTime",
					"description": "Date this item was created",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"createdBy": {
					"$ref": "#/definitions/ContactDTO",
					"description": "Contact information about who created this item"
				},
				"priority": {
					"description": "Priority keyword (human-readable). The number of possible values may vary by project",
					"type": "string"
				},
				"priorityOrdinal": {
					"format": "int32",
					"description": "Priority index (zero-based) in the keyword list with 0 being the lowest priority",
					"type": "integer"
				},
				"statusLabel": {
					"description": "Status (human-readable)",
					"type": "string"
				},
				"supportingDocumentCount": {
					"format": "int32",
					"description": "Number of supporting documents associated with item",
					"type": "integer"
				},
				"discussionItemCount": {
					"format": "int32",
					"description": "Number of discussion items associated with item",
					"type": "integer"
				},
				"descriptionText": {
					"description": "Description (plain-text), generally longer and may span multiple lines",
					"type": "string"
				},
				"dueDate": {
					"format": "DateTime",
					"description": "Date this Action Item is due",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"number": {
					"description": "Action Item ID, which may be user-assigned or automatically set",
					"type": "string"
				},
				"percentComplete": {
					"format": "int32",
					"description": "Percentage this Action Item is complete (0-100)",
					"maximum": 100,
					"minimum": 0,
					"type": "integer"
				},
				"statusType": {
					"description": "Status (programmatic value)",
					"type": "string"
				},
				"subject": {
					"description": "Subject (plain-text), generally a short single line",
					"type": "string"
				},
				"type": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "Indicates the type of the action item"
				}
			}
		},
		"ContactDTO": {
			"description": "Contact information",
			"required": [
				"id"
			],
			"type": "object",
			"properties": {
				"id": {
					"description": "Unique ID (Guid) of the contact",
					"type": "string"
				},
				"firstName": {
					"description": "First name, which may be given name or family name",
					"type": "string"
				},
				"lastName": {
					"description": "Last name, which may be given name or family name",
					"type": "string"
				},
				"emailAddress": {
					"description": "Email address",
					"type": "string"
				},
				"phoneNumber": {
					"description": "Phone number",
					"type": "string"
				},
				"companyName": {
					"description": "Company name",
					"type": "string"
				},
				"culture": {
					"description": "Culture code",
					"type": "string"
				}
			}
		},
		"KeywordDto[GenericKeyword]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"generic"
					],
					"type": "string"
				}
			}
		},
		"ActionItemsFilterRequestDto": {
			"description": "Represents the filter that can be used when getting a list of action items.",
			"type": "object",
			"properties": {
				"projectId": {
					"description": "Determines if the scope is set to a specific project.",
					"type": "string"
				},
				"to": {
					"description": "Set to \"me\" to get action items assigned TO the current user.\r\nIf {by} is also set to \"me\", the meaning is: items assigned either to me OR by me.",
					"type": "string"
				},
				"by": {
					"description": "Set to \"me\" to get action items assigned BY the current user.\r\nIf {to} is also set to \"me\", the meaning is: items assigned either to me OR by me.",
					"type": "string"
				},
				"types": {
					"description": "Filters on one or more types of the action items.",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				}
			}
		},
		"NascentActionItemDTO": {
			"description": "An Action Item to be created",
			"required": [
				"subject"
			],
			"type": "object",
			"properties": {
				"assignedTo": {
					"description": "List of contacts this item is assigned to\r\n<para>Description of availalbe types for IAssignedTo elements:</para><para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para><para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"assignedBy": {
					"$ref": "#/definitions/ContactIdDTO",
					"description": "Contact information about who assigned this item"
				},
				"descriptionText": {
					"description": "Description (plain-text), generally longer and may span multiple lines",
					"type": "string"
				},
				"dueDate": {
					"format": "DateTime",
					"description": "Date this Action Item is due",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"number": {
					"description": "Action Item ID, which may be user-assigned or automatically set",
					"type": "string"
				},
				"percentComplete": {
					"format": "int32",
					"description": "Percentage this Action Item is complete (0-100)",
					"maximum": 100,
					"minimum": 0,
					"type": "integer"
				},
				"statusType": {
					"description": "Status (programmatic value)",
					"type": "string"
				},
				"subject": {
					"description": "Subject (plain-text), generally a short single line",
					"type": "string"
				},
				"type": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "Indicates the type of the action item"
				}
			}
		},
		"IAssignedTo": {
			"type": "object",
			"properties": {}
		},
		"ContactIdDTO": {
			"description": "Contact id information",
			"required": [
				"id"
			],
			"type": "object",
			"properties": {
				"id": {
					"description": "Unique ID (Guid) of the contact",
					"type": "string"
				}
			}
		},
		"CreateActionItemResponse": {
			"type": "object",
			"properties": {
				"id": {
					"format": "uuid",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				}
			}
		},
		"ActionItemDetailDTO": {
			"description": "An Action Item in detail (as when processed individually)",
			"required": [
				"subject"
			],
			"type": "object",
			"properties": {
				"supportingDocuments": {
					"description": "List of supporting documents associated with this item.",
					"type": "array",
					"items": {
						"$ref": "#/definitions/SupportingDocument"
					}
				},
				"versionNumber": {
					"format": "int64",
					"description": "Project item's version number used to detect database concurrency violations.",
					"type": "integer"
				},
				"id": {
					"format": "uuid",
					"description": "Unique ID (Guid)",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"projectId": {
					"format": "uuid",
					"description": "Unique ID (Guid) of the project this Action Item belongs to",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"assignedTo": {
					"description": "List of contacts this item is assigned to",
					"type": "array",
					"items": {
						"$ref": "#/definitions/ContactDTO"
					}
				},
				"assignedBy": {
					"$ref": "#/definitions/ContactDTO",
					"description": "Contact information about who assigned this item"
				},
				"projectName": {
					"description": "Name of the project this Action Item belongs to",
					"type": "string"
				},
				"projectNumber": {
					"description": "Number of the project this Action Item belongs to",
					"type": "string"
				},
				"creationDate": {
					"format": "DateTime",
					"description": "Date this item was created",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"createdBy": {
					"$ref": "#/definitions/ContactDTO",
					"description": "Contact information about who created this item"
				},
				"priority": {
					"description": "Priority keyword (human-readable). The number of possible values may vary by project",
					"type": "string"
				},
				"priorityOrdinal": {
					"format": "int32",
					"description": "Priority index (zero-based) in the keyword list with 0 being the lowest priority",
					"type": "integer"
				},
				"statusLabel": {
					"description": "Status (human-readable)",
					"type": "string"
				},
				"supportingDocumentCount": {
					"format": "int32",
					"description": "Number of supporting documents associated with item",
					"type": "integer"
				},
				"discussionItemCount": {
					"format": "int32",
					"description": "Number of discussion items associated with item",
					"type": "integer"
				},
				"descriptionText": {
					"description": "Description (plain-text), generally longer and may span multiple lines",
					"type": "string"
				},
				"dueDate": {
					"format": "DateTime",
					"description": "Date this Action Item is due",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"number": {
					"description": "Action Item ID, which may be user-assigned or automatically set",
					"type": "string"
				},
				"percentComplete": {
					"format": "int32",
					"description": "Percentage this Action Item is complete (0-100)",
					"maximum": 100,
					"minimum": 0,
					"type": "integer"
				},
				"statusType": {
					"description": "Status (programmatic value)",
					"type": "string"
				},
				"subject": {
					"description": "Subject (plain-text), generally a short single line",
					"type": "string"
				},
				"type": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "Indicates the type of the action item"
				}
			}
		},
		"SupportingDocument": {
			"type": "object",
			"properties": {
				"projectFolderId": {
					"type": "string"
				},
				"projectFolderName": {
					"type": "string"
				},
				"pathArray": {
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"edmsVersionNumber": {
					"type": "string"
				},
				"type": {
					"description": "The type of the entity, namely, \"file\".",
					"type": "string",
					"readOnly": true
				},
				"contentType": {
					"description": "The content type (aka MIME type) of the file contents.",
					"type": "string"
				},
				"sizeInBytes": {
					"format": "int64",
					"description": "The size in bytes of the file contents.",
					"type": "integer"
				},
				"creationDate": {
					"format": "DateTime",
					"description": "The date and time the file was created.",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"name": {
					"description": "Name of the file or folder without the path.",
					"type": "string"
				},
				"lastModified": {
					"format": "DateTime",
					"description": "Date and time this file or folder was modified.",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				}
			}
		},
		"UpdatedActionItemDTO": {
			"description": "An Action Item to be updated",
			"required": [
				"subject"
			],
			"type": "object",
			"properties": {
				"id": {
					"format": "uuid",
					"description": "Unique ID (Guid)",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"projectId": {
					"format": "uuid",
					"description": "Unique ID (Guid) of the project this Action Item belongs to",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"priority": {
					"description": "Priority keyword (human-readable). The number of possible values may vary by project",
					"type": "string"
				},
				"priorityOrdinal": {
					"format": "int32",
					"description": "Priority index (zero-based) in the keyword list with 0 being the lowest priority",
					"type": "integer"
				},
				"statusLabel": {
					"description": "Status (human-readable)",
					"type": "string"
				},
				"versionNumber": {
					"format": "int64",
					"description": "Project item's version number used to detect database concurrency violations.",
					"type": "integer"
				},
				"assignedTo": {
					"description": "List of contacts this item is assigned to\r\n<para>Description of availalbe types for IAssignedTo elements:</para><para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para><para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"assignedBy": {
					"$ref": "#/definitions/ContactIdDTO",
					"description": "Contact information about who assigned this item"
				},
				"descriptionText": {
					"description": "Description (plain-text), generally longer and may span multiple lines",
					"type": "string"
				},
				"dueDate": {
					"format": "DateTime",
					"description": "Date this Action Item is due",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"number": {
					"description": "Action Item ID, which may be user-assigned or automatically set",
					"type": "string"
				},
				"percentComplete": {
					"format": "int32",
					"description": "Percentage this Action Item is complete (0-100)",
					"maximum": 100,
					"minimum": 0,
					"type": "integer"
				},
				"statusType": {
					"description": "Status (programmatic value)",
					"type": "string"
				},
				"subject": {
					"description": "Subject (plain-text), generally a short single line",
					"type": "string"
				},
				"type": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "Indicates the type of the action item"
				}
			}
		},
		"BatchOperation": {
			"description": "Represents the single operation of the Batch Patch request. See RFC specification documentation: https://tools.ietf.org/html/rfc6902",
			"type": "object",
			"properties": {
				"op": {
					"description": "Operation Type. Currently supported values are: `add`, `remove`",
					"enum": [
						"add",
						"remove"
					],
					"type": "string"
				},
				"path": {
					"description": "Relative path to resource on which operation will be done",
					"type": "string"
				}
			}
		},
		"BatchOperationResponse": {
			"description": "Represents response of the single operation of the Batch Patch request. See RFC specification documentation: https://tools.ietf.org/html/rfc6902",
			"type": "object",
			"properties": {
				"op": {
					"description": "Operation Type. Currently supported values are: `add`, `remove`",
					"enum": [
						"add",
						"remove"
					],
					"type": "string"
				},
				"status": {
					"format": "int32",
					"description": "HTTP status code of the operation response",
					"type": "integer"
				},
				"path": {
					"description": "Relative path to resource on which operation will be done",
					"type": "string"
				},
				"body": {
					"description": "Batch Operation response body in JSON format",
					"type": "object"
				}
			}
		},
		"PagingRequest": {
			"type": "object",
			"properties": {
				"offsetToken": {
					"type": "string"
				},
				"maxSize": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"PagedResponseDto[ListDiscussionItem]": {
			"type": "object",
			"properties": {
				"items": {
					"description": "The filtered list of items requested",
					"type": "array",
					"items": {
						"$ref": "#/definitions/ListDiscussionItem"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"ListDiscussionItem": {
			"type": "object",
			"properties": {
				"capabilities": {
					"description": "The set of capabilities the current user possesses for this item",
					"type": "array",
					"items": {
						"enum": [
							"edit",
							"delete"
						],
						"type": "string"
					}
				},
				"id": {
					"description": "The unique identifier for this item",
					"type": "string"
				},
				"createdBy": {
					"$ref": "#/definitions/ContactDTO",
					"description": "Contact information about who created this item"
				},
				"date": {
					"format": "DateTime",
					"description": "The date and time (UTC) the discussion took place",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"remarks": {
					"description": "The author's details (plain-text), may be long and may span multiple lines",
					"type": "string"
				},
				"action": {
					"$ref": "#/definitions/KeywordDto[DiscussionAction]",
					"description": "Indicates the action taken on the item"
				}
			}
		},
		"KeywordDto[DiscussionAction]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"completed",
						"approved",
						"rejected",
						"comment"
					],
					"type": "string"
				}
			}
		},
		"PagedResponseDto[DiscussionItem]": {
			"type": "object",
			"properties": {
				"items": {
					"description": "The filtered list of items requested",
					"type": "array",
					"items": {
						"$ref": "#/definitions/DiscussionItem"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"DiscussionItem": {
			"description": "A Discussion Item attached to a specific action item",
			"type": "object",
			"properties": {
				"id": {
					"description": "The unique identifier for this item",
					"type": "string"
				},
				"createdBy": {
					"$ref": "#/definitions/ContactDTO",
					"description": "Contact information about who created this item"
				},
				"date": {
					"format": "DateTime",
					"description": "The date and time (UTC) the discussion took place",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"remarks": {
					"description": "The author's details (plain-text), may be long and may span multiple lines",
					"type": "string"
				},
				"action": {
					"$ref": "#/definitions/KeywordDto[DiscussionAction]",
					"description": "Indicates the action taken on the item"
				}
			}
		},
		"NascentDiscussionItemDto": {
			"description": "A Discussion Item to be created",
			"type": "object",
			"properties": {
				"remarks": {
					"description": "The author's details (plain-text), may be long and may span multiple lines",
					"type": "string"
				},
				"action": {
					"$ref": "#/definitions/KeywordDto[DiscussionAction]",
					"description": "Indicates the action taken on the item"
				}
			}
		},
		"CompanySelfDto": {
			"description": "Defines a company linked to a NPCS server.",
			"type": "object",
			"properties": {
				"id": {
					"description": "The identifier of the company",
					"type": "string"
				},
				"name": {
					"description": "The name of the company",
					"type": "string"
				},
				"logoUrl": {
					"description": "The url of the company's logo",
					"type": "string"
				}
			}
		},
		"PagedResponseDto[ContractDTO]": {
			"type": "object",
			"properties": {
				"items": {
					"description": "The filtered list of items requested",
					"type": "array",
					"items": {
						"$ref": "#/definitions/ContractDTO"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"ContractDTO": {
			"type": "object",
			"properties": {
				"id": {
					"format": "uuid",
					"description": "The GUID of the contract",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"subject": {
					"description": "The subject of the contract",
					"type": "string"
				},
				"number": {
					"description": "The number of the contract",
					"type": "string"
				}
			}
		},
		"FolderPatchBody": {
			"description": "A set of changes to apply to a file or folder",
			"type": "object",
			"properties": {
				"name": {
					"description": "The value to update the name property to",
					"type": "string"
				}
			}
		},
		"CreateFileUploadSessionRequest": {
			"description": "Request initiating file upload session",
			"type": "object",
			"properties": {
				"folderParts": {
					"description": "Path from the root folder to the folder that upload is being made",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"requestedFilename": {
					"description": "Desired name of the uploaded file",
					"type": "string"
				},
				"fileSizeinBytes": {
					"format": "int64",
					"description": "Size of uploaded file (in bytes)",
					"type": "integer"
				},
				"mimeType": {
					"description": "Mime type of uploaded file",
					"type": "string"
				},
				"conflictBehavior": {
					"description": "Information about the conflict behavior that will be applied when file with requested name already exists. Possible values: fail, overwrite, rename",
					"enum": [
						"fail",
						"overwrite",
						"rename"
					],
					"type": "string"
				},
				"batchId": {
					"description": "Id of the batch file upload",
					"type": "string"
				},
				"allowOverwrite": {
					"type": "boolean"
				}
			}
		},
		"FileUploadSessionResource": {
			"type": "object",
			"properties": {
				"uploadSessionId": {
					"type": "string",
					"readOnly": true
				},
				"status": {
					"enum": [
						"Open",
						"UploadComplete"
					],
					"type": "string",
					"readOnly": true
				},
				"result": {
					"$ref": "#/definitions/IFileUploadSessionResult",
					"readOnly": true
				}
			}
		},
		"IFileUploadSessionResult": {
			"type": "object",
			"properties": {}
		},
		"PatchFileUploadSessionRequest": {
			"type": "object",
			"properties": {
				"status": {
					"enum": [
						"Open",
						"UploadComplete"
					],
					"type": "string"
				},
				"region": {
					"type": "string"
				},
				"regionQualifier": {
					"type": "string"
				},
				"relativeDownloadPath": {
					"type": "string"
				}
			}
		},
		"FolderContentsRequestBody": {
			"type": "object",
			"properties": {
				"pathToFolder": {
					"description": "The path to the requested folder delimited by \"/\".",
					"type": "string"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest",
					"description": "Parameters specifying the page of items to return."
				}
			}
		},
		"FolderContentsResponse": {
			"type": "object",
			"properties": {
				"folderName": {
					"description": "The name of this folder without the path.",
					"type": "string"
				},
				"folderPath": {
					"description": "The path to the parent of this folder. If this folder is at the root, folderPath will be empty. Folder names in the path are delimited by \"/\".",
					"type": "string"
				},
				"items": {
					"description": "List of subfolders followed by files in this folder. Subfolders are sorted by name and files are sorted by name in ascending order.",
					"type": "array",
					"items": {
						"$ref": "#/definitions/FolderOrFile"
					}
				},
				"paging": {
					"$ref": "#/definitions/PagingResponse",
					"description": "Parameters to get the next page of items."
				}
			}
		},
		"FolderOrFile": {
			"type": "object",
			"properties": {
				"name": {
					"description": "Name of the file or folder without the path.",
					"type": "string"
				},
				"lastModified": {
					"format": "DateTime",
					"description": "Date and time this file or folder was modified.",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"type": {
					"description": "The type of the entity. Either \"file\" or \"folder\".",
					"type": "string",
					"readOnly": true
				}
			}
		},
		"PagingResponse": {
			"type": "object",
			"properties": {
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				}
			}
		},
		"CreateFolderRequest": {
			"type": "object",
			"properties": {
				"parentFolderPath": {
					"description": "The path to the folder to contain the newly created subfolder, delimited by \"/\".\r\nEmpty or null to create a folder at the root level.",
					"type": "string"
				},
				"name": {
					"description": "The name of the subfolder to be created.",
					"type": "string"
				}
			}
		},
		"Folder": {
			"description": "Folder (aka directory) metadata",
			"type": "object",
			"properties": {
				"type": {
					"description": "The type of the entity, namely, \"folder\".",
					"type": "string",
					"readOnly": true
				},
				"name": {
					"description": "Name of the file or folder without the path.",
					"type": "string"
				},
				"lastModified": {
					"format": "DateTime",
					"description": "Date and time this file or folder was modified.",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				}
			}
		},
		"KeywordsFilterRequestDto": {
			"description": "Represents the different filters that can be used to get keywords.",
			"required": [
				"listType"
			],
			"type": "object",
			"properties": {
				"listType": {
					"description": "Filters the result to include only items from a specific list type.",
					"enum": [
						"action_item_type",
						"discussion_actions",
						"submittal_discipline_list",
						"submittal_keyword_list",
						"submittal_specsection_list",
						"submittal_action_list",
						"rfi_action_list",
						"rfi_reasons_list",
						"rfi_discipline_list",
						"rfi_keyword_list",
						"rfi_types_list",
						"transfer_methods_list"
					],
					"type": "string"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest",
					"description": "Limits the number of items returned"
				},
				"query": {
					"description": "Used to filter keywords by name and description",
					"type": "string"
				}
			}
		},
		"KeywordsFilterResponseDto": {
			"description": "Represents a filtered list of keywords.",
			"type": "object",
			"properties": {
				"keywordList": {
					"$ref": "#/definitions/KeywordListDto",
					"description": "The keyword list from which the keywords originate."
				},
				"items": {
					"description": "The filtered list of items requested",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordListDefinitionDto"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"KeywordListDto": {
			"description": "Information about a keyword list and its keywords.",
			"type": "object",
			"properties": {
				"id": {
					"description": "The keyword list identifier.",
					"type": "string"
				},
				"name": {
					"description": "The name of the keyword list.\r\nThis corresponds to the Project Center administration \"Keywords\" tab column named \"List Name\".",
					"type": "string"
				},
				"type": {
					"description": "The type of the keyword list.\r\nThis corresponds to the Project Center administration \"Keywords\" tab column named \"List Type\".",
					"enum": [
						"action_item_type",
						"discussion_actions",
						"submittal_discipline_list",
						"submittal_keyword_list",
						"submittal_specsection_list",
						"submittal_action_list",
						"rfi_action_list",
						"rfi_reasons_list",
						"rfi_discipline_list",
						"rfi_keyword_list",
						"rfi_types_list",
						"transfer_methods_list"
					],
					"type": "string"
				},
				"required": {
					"description": "Determines if the keyword list is required or not.",
					"type": "boolean"
				},
				"allowCustom": {
					"description": "Determines whether or not keyword values are constrained to the values from the keyword list.",
					"type": "boolean"
				}
			}
		},
		"KeywordListDefinitionDto": {
			"description": "Represent the details of a keyword.",
			"type": "object",
			"properties": {
				"name": {
					"description": "The name of the keyword.\r\nThis corresponds to the Project Center keyword list dialog's \"Name\" column.",
					"type": "string"
				},
				"type": {
					"description": "The type of the keyword.\r\nThis corresponds to the Project Center keyword list dialog's \"Type\" column.",
					"type": "string"
				},
				"description": {
					"description": "The description of the keyword.\r\nThis corresponds to the Project Center keyword list dialog's \"Description\" column.",
					"type": "string"
				},
				"displayOrder": {
					"format": "int32",
					"description": "The display order to use for sorting keywords.",
					"type": "integer"
				}
			}
		},
		"AllKeywordsFilterRequestDto": {
			"description": "Represents the different filters that can be used to get all keywords.",
			"required": [
				"listType"
			],
			"type": "object",
			"properties": {
				"listType": {
					"description": "Filters the result to include only items from a specific list type.",
					"enum": [
						"action_item_type",
						"discussion_actions",
						"submittal_discipline_list",
						"submittal_keyword_list",
						"submittal_specsection_list"
					],
					"type": "string"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest",
					"description": "Limits the number of items returned."
				},
				"query": {
					"description": "Used to filter keywords by name and description",
					"type": "string"
				}
			}
		},
		"AllKeywordsFilterResponseDto": {
			"description": "Represents a filtered list of keywords.",
			"type": "object",
			"properties": {
				"items": {
					"description": "The filtered list of items requested",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordListDefinitionDto"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"SubmittalActionKeywordsRequestDTO": {
			"description": "Represents the different filters that can be used to get submittal action keywords.",
			"type": "object",
			"properties": {
				"paging": {
					"$ref": "#/definitions/PagingRequest",
					"description": "Limits the number of items returned."
				},
				"query": {
					"description": "Used to filter keywords by name and description",
					"type": "string"
				}
			}
		},
		"WorkflowActionKeywordsResponseDTO": {
			"type": "object",
			"properties": {
				"items": {
					"description": "The filtered list of items requested",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordListDefinitionDto"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"ActionKeywordsForSubmittalRequestDTO": {
			"description": "Represents the different filters that can be used to get submittal action keywords.",
			"type": "object",
			"properties": {
				"submittalId": {
					"format": "uuid",
					"description": "Submittal Id for `Receive Pending Reviewer Response` action keywords",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest",
					"description": "Limits the number of items returned."
				},
				"query": {
					"description": "Used to filter keywords by name and description",
					"type": "string"
				}
			}
		},
		"ActionKeywordsForRfiRequestDTO": {
			"description": "Represents the different filters that can be used to get RFI action keywords.",
			"type": "object",
			"properties": {
				"rfiId": {
					"format": "uuid",
					"description": "RFI Id for `Receive Pending Reviewer Response` action keywords",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest",
					"description": "Limits the number of items returned."
				},
				"query": {
					"description": "Used to filter keywords by name and description",
					"type": "string"
				}
			}
		},
		"PermissionsRequest": {
			"required": [
				"files"
			],
			"type": "object",
			"properties": {
				"files": {
					"description": "A list of project and the files container in that project with the users permission level on each projectFile",
					"type": "array",
					"items": {
						"$ref": "#/definitions/PermissionsProjectRequest"
					}
				}
			}
		},
		"PermissionsProjectRequest": {
			"required": [
				"projectId",
				"paths"
			],
			"type": "object",
			"properties": {
				"projectId": {
					"format": "uuid",
					"description": "The Id of the project the list of files are associated with",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"paths": {
					"description": "A list of files and the users permission level on the projectFile",
					"type": "array",
					"items": {
						"$ref": "#/definitions/PermissionsProjectFileRequest"
					}
				}
			}
		},
		"PermissionsProjectFileRequest": {
			"required": [
				"projectRootFolderId",
				"filename"
			],
			"type": "object",
			"properties": {
				"lastKnownPermission": {
					"description": "The permissions this user has on this projectFile. Valid values are: allow or deny",
					"type": "string"
				},
				"projectRootFolderId": {
					"description": "The Id of the root folder of the project for this projectFile",
					"type": "string"
				},
				"pathToFolder": {
					"description": "The relative path of this projectFile",
					"type": "string"
				},
				"filename": {
					"description": "The name of the projectFile whose permissions are being checked",
					"type": "string"
				}
			}
		},
		"PermissionsResponse": {
			"required": [
				"files"
			],
			"type": "object",
			"properties": {
				"files": {
					"description": "A list of project and the files container in that project with the users permission level on each projectFile",
					"type": "array",
					"items": {
						"$ref": "#/definitions/PermissionsProjectResponse"
					}
				}
			}
		},
		"PermissionsProjectResponse": {
			"required": [
				"projectId",
				"paths"
			],
			"type": "object",
			"properties": {
				"projectId": {
					"format": "uuid",
					"description": "The Id of the project the list of files are associated with",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"paths": {
					"description": "A list of files and the users permission level on the projectFile",
					"type": "array",
					"items": {
						"$ref": "#/definitions/PermissionsProjectFileResponse"
					}
				}
			}
		},
		"PermissionsProjectFileResponse": {
			"required": [
				"permission",
				"projectRootFolderId",
				"filename"
			],
			"type": "object",
			"properties": {
				"permission": {
					"description": "The permissions this user has on this projectFile. Valid values are: allow or deny",
					"type": "string"
				},
				"reason": {
					"description": "The reason this user has been denied access to the projectFile.",
					"type": "string"
				},
				"projectRootFolderId": {
					"description": "The Id of the root folder of the project for this projectFile",
					"type": "string"
				},
				"pathToFolder": {
					"description": "The relative path of this projectFile",
					"type": "string"
				},
				"filename": {
					"description": "The name of the projectFile whose permissions are being checked",
					"type": "string"
				}
			}
		},
		"EmailPreviewResponse": {
			"type": "object",
			"properties": {
				"dateSent": {
					"format": "DateTime",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"subject": {
					"type": "string"
				},
				"sender": {
					"$ref": "#/definitions/EmailPreviewContact"
				},
				"from": {
					"$ref": "#/definitions/EmailPreviewContact"
				},
				"to": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/EmailPreviewContact"
					}
				},
				"cc": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/EmailPreviewContact"
					}
				},
				"attachments": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/EmailPreviewAttachment"
					}
				},
				"body": {
					"type": "string"
				}
			}
		},
		"EmailPreviewContact": {
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"address": {
					"type": "string"
				}
			}
		},
		"EmailPreviewAttachment": {
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"size": {
					"format": "int64",
					"type": "integer"
				}
			}
		},
		"PagedResponseDto[Project]": {
			"type": "object",
			"properties": {
				"items": {
					"description": "The filtered list of items requested",
					"type": "array",
					"items": {
						"$ref": "#/definitions/Project"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"Project": {
			"description": "Contains basic information about a project, will mostly be used for a list of projects.",
			"type": "object",
			"properties": {
				"id": {
					"description": "The project ID.",
					"type": "string"
				},
				"name": {
					"description": "The name of the project.",
					"type": "string"
				},
				"number": {
					"description": "The project number.",
					"type": "string"
				},
				"npcServer": {
					"description": "Name of the NPCS server hosting the project.",
					"type": "string"
				},
				"isAdmin": {
					"description": "True if the user making the request is an admin on this project, false otherwise",
					"type": "boolean"
				},
				"itemsToFileLabel": {
					"description": "The label used for filing items",
					"type": "string"
				}
			}
		},
		"Error": {
			"type": "object",
			"properties": {
				"errorMessage": {
					"description": "The error message in case of a failure.",
					"type": "string"
				}
			}
		},
		"ProjectsResponse": {
			"type": "object",
			"properties": {
				"projects": {
					"description": "The project items.",
					"type": "array",
					"items": {
						"$ref": "#/definitions/Project"
					}
				}
			}
		},
		"ProjectDetails": {
			"description": "Contains detailed information about a project.",
			"type": "object",
			"properties": {
				"logoUrl": {
					"description": "The logo url from the Template Style for forms and notifications used by the project.",
					"type": "string"
				},
				"culture": {
					"description": "The culture used by the project.\r\nThis corresponds to the DataCulture (the Template Style culture) of the project.",
					"type": "string"
				},
				"autoFileMailboxFolderName": {
					"description": "The name of the subfolder in a user's Newforma - Items to File folder that is used for auto filing into this project",
					"type": "string"
				},
				"id": {
					"description": "The project ID.",
					"type": "string"
				},
				"name": {
					"description": "The name of the project.",
					"type": "string"
				},
				"number": {
					"description": "The project number.",
					"type": "string"
				},
				"npcServer": {
					"description": "Name of the NPCS server hosting the project.",
					"type": "string"
				},
				"isAdmin": {
					"description": "True if the user making the request is an admin on this project, false otherwise",
					"type": "boolean"
				},
				"itemsToFileLabel": {
					"description": "The label used for filing items",
					"type": "string"
				}
			}
		},
		"ProjectFoldersResponse": {
			"type": "object",
			"properties": {
				"projectId": {
					"format": "uuid",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"projectFolders": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/ProjectFolder"
					}
				},
				"isAdmin": {
					"type": "boolean"
				}
			}
		},
		"ProjectFolder": {
			"type": "object",
			"properties": {
				"id": {
					"type": "string"
				},
				"name": {
					"type": "string"
				},
				"lastModified": {
					"format": "DateTime",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"folder": {
					"$ref": "#/definitions/EDMSObjectIdDto"
				}
			}
		},
		"EDMSObjectIdDto": {
			"type": "object",
			"properties": {
				"path": {
					"type": "string"
				},
				"pluginConfigId": {
					"type": "string"
				},
				"providerId": {
					"type": "string"
				}
			}
		},
		"ProjectSettings": {
			"type": "object",
			"properties": {
				"submittals": {
					"$ref": "#/definitions/ActivityCenterProjectSettings"
				},
				"rfis": {
					"$ref": "#/definitions/ActivityCenterProjectSettings"
				},
				"transfer": {
					"$ref": "#/definitions/FileTransferSettings"
				}
			}
		},
		"ActivityCenterProjectSettings": {
			"type": "object",
			"properties": {
				"numberEntryMode": {
					"enum": [
						"AutoNumber",
						"FromKeywordField",
						"Manual",
						"FromRfiTypeKeyword"
					],
					"type": "string"
				},
				"dueDateOffsetInDays": {
					"format": "int32",
					"type": "integer"
				},
				"defaultDueDate": {
					"format": "DateTime",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"useCalendarDaysForDueDate": {
					"type": "boolean"
				},
				"reviewResponseDueDateOffsetInDays": {
					"format": "int32",
					"type": "integer"
				},
				"reviewResponseDueDate": {
					"format": "DateTime",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"useCalendarDaysForReviewResponseDueDate": {
					"type": "boolean"
				},
				"enabled": {
					"type": "boolean"
				}
			}
		},
		"FileTransferSettings": {
			"type": "object",
			"properties": {
				"enabled": {
					"type": "boolean"
				},
				"transferWithTransmittal": {
					"type": "boolean"
				},
				"transferExpiresByDefault": {
					"type": "boolean"
				},
				"defaultExpireDays": {
					"format": "int32",
					"type": "integer"
				},
				"allowPartialDownload": {
					"type": "boolean"
				},
				"requireNixLoginForDownload": {
					"type": "boolean"
				}
			}
		},
		"ProjectTeamFilterDto": {
			"type": "object",
			"properties": {
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				},
				"query": {
					"type": "string"
				}
			}
		},
		"FilterResponseDto[ProjectTeamItemDto]": {
			"type": "object",
			"properties": {
				"items": {
					"description": "The filtered list of items requested",
					"type": "array",
					"items": {
						"$ref": "#/definitions/ProjectTeamItemDto"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"ProjectTeamItemDto": {
			"type": "object",
			"properties": {
				"type": {
					"enum": [
						"group",
						"member"
					],
					"type": "string"
				},
				"details": {
					"type": "object"
				}
			}
		},
		"ProjectTeamMemberFilterDto": {
			"type": "object",
			"properties": {
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				},
				"lastModifiedUtc": {
					"format": "DateTime",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"groupIds": {
					"type": "string"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				}
			}
		},
		"SourceInfoDto": {
			"description": "Useful when synchronizing data into Newforma from a third-party system,\r\nthe source information links the information stored in Newforma with that originating in the third-party system.",
			"type": "object",
			"properties": {
				"sourcePrimaryKey": {
					"description": "The identifier of data object in the third-party system. May be any string or serialized object as defined by the third-party system.",
					"type": "string"
				},
				"sourceDescriptor": {
					"description": "A short descriptive (human-readable) name of the third-party system or subsystem.",
					"type": "string"
				}
			}
		},
		"FilterResponseDto[ProjectTeamMemberDto]": {
			"type": "object",
			"properties": {
				"items": {
					"description": "The filtered list of items requested",
					"type": "array",
					"items": {
						"$ref": "#/definitions/ProjectTeamMemberDto"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"ProjectTeamMemberDto": {
			"type": "object",
			"properties": {
				"permissionSetId": {
					"type": "string"
				},
				"groups": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/ProjectTeamGroupRefDto"
					}
				},
				"id": {
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				},
				"projectRef": {
					"$ref": "#/definitions/ProjectReferenceDto"
				},
				"contactRef": {
					"$ref": "#/definitions/ContactReferenceDto"
				}
			}
		},
		"ProjectTeamGroupRefDto": {
			"type": "object",
			"properties": {
				"id": {
					"type": "string"
				}
			}
		},
		"ProjectReferenceDto": {
			"type": "object",
			"properties": {
				"id": {
					"format": "uuid",
					"description": "GUID of the project",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"name": {
					"description": "The project name",
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"ContactReferenceDto": {
			"type": "object",
			"properties": {
				"id": {
					"description": "ID (typically a GUID)",
					"type": "string"
				},
				"firstName": {
					"description": "The name to appear first, the given name in most western cultures",
					"type": "string"
				},
				"lastName": {
					"description": "The name to appear last, the family name in most western cultures",
					"type": "string"
				},
				"emailAddress": {
					"description": "Must match typical email address form",
					"type": "string"
				},
				"isActive": {
					"description": "If false the user can not login into info exchange and will not show up in project teams",
					"type": "boolean"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"FilterResponseDto[ProjectTeamMemberRefDto]": {
			"type": "object",
			"properties": {
				"items": {
					"description": "The filtered list of items requested",
					"type": "array",
					"items": {
						"$ref": "#/definitions/ProjectTeamMemberRefDto"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"ProjectTeamMemberRefDto": {
			"type": "object",
			"properties": {
				"id": {
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				},
				"projectRef": {
					"$ref": "#/definitions/ProjectReferenceDto"
				},
				"contactRef": {
					"$ref": "#/definitions/ContactReferenceDto"
				}
			}
		},
		"ProjectTeamMemberCreateRequestDto": {
			"type": "object",
			"properties": {
				"contactId": {
					"type": "string"
				},
				"calculatePermissionSet": {
					"type": "boolean"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				},
				"permissionSetId": {
					"type": "string"
				}
			}
		},
		"CreateResponseDto": {
			"type": "object",
			"properties": {
				"id": {
					"type": "string"
				}
			}
		},
		"ProjectTeamMemberUpdateRequestDto": {
			"type": "object",
			"properties": {
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				},
				"permissionSetId": {
					"type": "string"
				}
			}
		},
		"PagedResponseDto[RfiListDTO]": {
			"type": "object",
			"properties": {
				"items": {
					"description": "The filtered list of items requested",
					"type": "array",
					"items": {
						"$ref": "#/definitions/RfiListDTO"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"RfiListDTO": {
			"type": "object",
			"properties": {
				"id": {
					"format": "uuid",
					"description": "The GUID of the project item",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"subject": {
					"description": "The subject of the project item (plain text)",
					"type": "string"
				},
				"number": {
					"description": "The RFI number (ID)",
					"type": "string"
				},
				"projectId": {
					"format": "uuid",
					"description": "The id of the project (ID)",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"dueDate": {
					"format": "DateTime",
					"description": "The date when the anticipated incoming RFI is (or was) due to arrive.\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[WorkflowActionStatus]",
					"description": "The workflow status from the UAC [PROJECT_ITEM_TYPE] Workflow Status for its project, e.g., \"Expected\", \"Open\""
				},
				"disciplines": {
					"description": "The list of disciplines either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"allReviewsRecorded": {
					"description": "The allReviewsRecorded flag of the RFI.",
					"type": "boolean"
				},
				"inProgressWorkflowActionType": {
					"$ref": "#/definitions/KeywordDto[WorkflowCompletedActionType]",
					"description": "Current workflow action type of RFI."
				},
				"forwardedReviews": {
					"description": "The parsed workflows of the RFI. Only for forwarded RFI.",
					"type": "array",
					"items": {
						"$ref": "#/definitions/ForwardedReviewDTO"
					}
				},
				"reviewDueDate": {
					"description": "The review due date of the RFI. Only for forwarded RFI.",
					"type": "boolean"
				}
			}
		},
		"KeywordDto[WorkflowActionStatus]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"closed",
						"draft",
						"expected",
						"open",
						"pending",
						"forwarded"
					],
					"type": "string"
				}
			}
		},
		"KeywordDto[WorkflowCompletedActionType]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"pendingReceipt",
						"received",
						"forwarded",
						"pendingReviewResponse",
						"reviewResponse",
						"reopened",
						"closed",
						"respondedAndClosed",
						"sent",
						"sentAndClosed"
					],
					"type": "string"
				}
			}
		},
		"ForwardedReviewDTO": {
			"type": "object",
			"properties": {
				"forwarder": {
					"$ref": "#/definitions/ContactDTO",
					"description": "The forwarder details"
				},
				"reviews": {
					"description": "List of reviews",
					"type": "array",
					"items": {
						"$ref": "#/definitions/ReviewDTO"
					}
				}
			}
		},
		"ReviewDTO": {
			"type": "object",
			"properties": {
				"id": {
					"format": "uuid",
					"description": "The GUID of the project item",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"reviewer": {
					"$ref": "#/definitions/ContactDTO",
					"description": "The reviewer details"
				},
				"action": {
					"$ref": "#/definitions/KeywordDto[WorkflowAction]",
					"description": "The action that reviewer made e.g. \"No Action Taken\", \"Reviewed\", \"No Exceptions\", \"Rejected\", \"Revise and Resubmit\""
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[ReviewStatus]",
					"description": "The workflow status from the UAC [PROJECT_ITEM_TYPE] Workflow Status for its project, e.g., \"Pending\", \"Open\", \"Outstanding\", \"Recorded\""
				},
				"dueDate": {
					"format": "DateTime",
					"description": "The date when the anticipated incoming submittal is (or was) due to arrive.\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				}
			}
		},
		"KeywordDto[WorkflowAction]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"close",
						"close_approve",
						"close_no_action_taken",
						"close_rejected",
						"final_receive",
						"forward",
						"receive",
						"record_response",
						"reopen",
						"respond_and_close_approve",
						"respond_and_close_no_action_taken",
						"respond_and_close_rejected",
						"respond_and_close_resubmit",
						"send",
						"send_and_close",
						"send_and_close_approve",
						"BasicTransmittalOutgoing"
					],
					"type": "string"
				}
			}
		},
		"KeywordDto[ReviewStatus]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"WorkflowPending",
						"Record_response",
						"Outstanding",
						"Overdue"
					],
					"type": "string"
				}
			}
		},
		"RfisGroupingResponse": {
			"type": "object",
			"properties": {
				"pending": {
					"description": "The list of RFIs with status: pending",
					"type": "array",
					"items": {
						"$ref": "#/definitions/RfiListDTO"
					}
				},
				"open": {
					"description": "The list of RFIs with status: open",
					"type": "array",
					"items": {
						"$ref": "#/definitions/RfiListDTO"
					}
				},
				"forwarded": {
					"description": "The list of RFIs with status: forwarded",
					"type": "array",
					"items": {
						"$ref": "#/definitions/RfiListDTO"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"ValidationResultModel": {
			"type": "object",
			"properties": {
				"errorMessage": {
					"type": "string",
					"readOnly": true
				},
				"modelState": {
					"type": "object",
					"additionalProperties": {
						"type": "array",
						"items": {
							"type": "string"
						}
					},
					"readOnly": true
				}
			}
		},
		"RFIDetailsDto": {
			"type": "object",
			"properties": {
				"id": {
					"format": "uuid",
					"description": "RFI id",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"number": {
					"description": "The internal reference number for the RFI",
					"type": "string"
				},
				"subject": {
					"description": "The subject of the RFI",
					"type": "string"
				},
				"project": {
					"$ref": "#/definitions/ProjectDto",
					"description": "The details of the project, the RFI is associated with"
				},
				"dueDate": {
					"format": "DateTime",
					"description": "The date a response must be sent back for the RFI\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"receivedDate": {
					"format": "DateTime",
					"description": "The date the original review was received\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"senderId": {
					"description": "The external id for the RFI.",
					"type": "string"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[WorkflowActionStatus]",
					"description": "The workflow status from the UAC [PROJECT_ITEM_TYPE] Workflow Status for its project, e.g., \"Expected\", \"Open\""
				},
				"from": {
					"$ref": "#/definitions/ContactDTO",
					"description": "The sender of the original review"
				},
				"to": {
					"description": "The recipient of the original review",
					"type": "array",
					"items": {
						"$ref": "#/definitions/ContactDTO"
					}
				},
				"version": {
					"description": "Version number for use in optimistic concurrency check when modifying RFI",
					"type": "string"
				},
				"keywords": {
					"description": "The list of keywords either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"disciplines": {
					"description": "The list of disciplines either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"internalNotes": {
					"description": "Internal notes of the RFI",
					"type": "string"
				},
				"mostRecentWorkflowAction": {
					"$ref": "#/definitions/WorkflowActionDto",
					"description": "Most recent workflow action"
				},
				"question": {
					"description": "Question asked in the RFI",
					"type": "string"
				},
				"reasons": {
					"description": "The list of reasons for the RFI",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"type": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "Type of RFI."
				},
				"suggestion": {
					"description": "Suggestion for the RFI question",
					"type": "string"
				},
				"workflowActionsCount": {
					"format": "int32",
					"description": "Number of workflow actions",
					"type": "integer"
				},
				"filesCount": {
					"format": "int32",
					"description": "Number of associated files",
					"type": "integer"
				},
				"lockId": {
					"description": "Lock id (if exists) that indicated that submittal has an action in-progress",
					"type": "string"
				},
				"contract": {
					"$ref": "#/definitions/ContractDTO",
					"description": "The contract assosiated with the RFI"
				}
			}
		},
		"ProjectDto": {
			"type": "object",
			"properties": {
				"id": {
					"format": "uuid",
					"description": "Project id",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"name": {
					"description": "Project name",
					"type": "string"
				},
				"number": {
					"description": "Project number",
					"type": "string"
				}
			}
		},
		"WorkflowActionDto": {
			"type": "object",
			"properties": {
				"id": {
					"format": "uuid",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"actionType": {
					"$ref": "#/definitions/KeywordDto[WorkflowCompletedActionType]"
				},
				"actionDate": {
					"format": "DateTime",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"files": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/WorkflowActionExistingFileDto"
					}
				},
				"purpose": {
					"$ref": "#/definitions/KeywordDto[WorkflowCompletedActionType]"
				},
				"remarks": {
					"type": "string"
				}
			}
		},
		"WorkflowActionExistingFileDto": {
			"type": "object",
			"properties": {
				"modifiedDate": {
					"format": "DateTime",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"projectFolderId": {
					"type": "string"
				},
				"projectFolderName": {
					"type": "string"
				},
				"pathArray": {
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"transferStatus": {
					"enum": [
						"Completed",
						"InProgress",
						"Error"
					],
					"type": "string"
				},
				"fileName": {
					"type": "string"
				},
				"sizeInBytes": {
					"type": "string"
				},
				"contentType": {
					"type": "string"
				}
			}
		},
		"RfiLogRequestDTO": {
			"required": [
				"to",
				"from",
				"subject",
				"type",
				"receivedDate",
				"purpose",
				"via",
				"question"
			],
			"type": "object",
			"properties": {
				"to": {
					"description": "The recipient of the original review\r\n<para>Description of availalbe types for IAssignedTo elements:</para><para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para><para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"from": {
					"$ref": "#/definitions/IAssignedTo",
					"description": "The sender of the original review\r\n<para>Description of availalbe types for IAssignedTo elements:</para><para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para><para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>"
				},
				"subject": {
					"description": "RFI subject",
					"type": "string"
				},
				"type": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "RFI type"
				},
				"receivedDate": {
					"format": "DateTime",
					"description": "The date the original review was received\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"purpose": {
					"$ref": "#/definitions/KeywordDto[ProjectItemActionType]",
					"description": "Action type for the RFI"
				},
				"via": {
					"$ref": "#/definitions/KeywordDto[TransferMethodKeyword]",
					"description": "Method with which RFI was received"
				},
				"question": {
					"description": "Question of the RFI",
					"type": "string"
				},
				"rfiNumber": {
					"description": "Unique RFI number",
					"type": "string"
				},
				"senderId": {
					"description": "The external id for the RFI.",
					"type": "string"
				},
				"reasons": {
					"description": "The list of keywords either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"dueDate": {
					"format": "DateTime",
					"description": "The date a response must be sent back for the RFI\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"disciplines": {
					"description": "The list of disciplines either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"keywords": {
					"description": "The list of keywords either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"suggestion": {
					"description": "The suggestion passed with the RFI",
					"type": "string"
				},
				"internalNotes": {
					"description": "Internal notes of the RFI",
					"type": "string"
				},
				"contractId": {
					"format": "uuid",
					"description": "The contract associated with RFI",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"rfiId": {
					"format": "uuid",
					"description": "Id RFI would have after creation",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"reminder": {
					"format": "int64",
					"description": "Number of day before due date to send a reminder",
					"maximum": 365,
					"minimum": 0,
					"type": "integer"
				},
				"attachments": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/WorkflowActionUploadFileDto"
					}
				}
			}
		},
		"KeywordDto[ProjectItemActionType]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"log",
						"receive",
						"forward",
						"receivePendingReviewerResponse",
						"recordResponse",
						"respondAndClose",
						"close"
					],
					"type": "string"
				}
			}
		},
		"KeywordDto[TransferMethodKeyword]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"transferMethod"
					],
					"type": "string"
				}
			}
		},
		"WorkflowActionUploadFileDto": {
			"type": "object",
			"properties": {
				"fileName": {
					"type": "string"
				},
				"sizeInBytes": {
					"type": "string"
				},
				"contentType": {
					"type": "string"
				}
			}
		},
		"WorkflowActionQueuedResponseDto": {
			"type": "object",
			"properties": {
				"folderParts": {
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"lockId": {
					"type": "string"
				}
			}
		},
		"RfiCompleteLogRequestDTO": {
			"required": [
				"to",
				"from",
				"subject",
				"type",
				"receivedDate",
				"purpose",
				"via",
				"question"
			],
			"type": "object",
			"properties": {
				"folderParts": {
					"description": "Array of folder parts with location to save attachment files",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"lockId": {
					"description": "Project Item Lock identifier",
					"type": "string"
				},
				"to": {
					"description": "The recipient of the original review\r\n<para>Description of availalbe types for IAssignedTo elements:</para><para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para><para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"from": {
					"$ref": "#/definitions/IAssignedTo",
					"description": "The sender of the original review\r\n<para>Description of availalbe types for IAssignedTo elements:</para><para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para><para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>"
				},
				"subject": {
					"description": "RFI subject",
					"type": "string"
				},
				"type": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "RFI type"
				},
				"receivedDate": {
					"format": "DateTime",
					"description": "The date the original review was received\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"purpose": {
					"$ref": "#/definitions/KeywordDto[ProjectItemActionType]",
					"description": "Action type for the RFI"
				},
				"via": {
					"$ref": "#/definitions/KeywordDto[TransferMethodKeyword]",
					"description": "Method with which RFI was received"
				},
				"question": {
					"description": "Question of the RFI",
					"type": "string"
				},
				"rfiNumber": {
					"description": "Unique RFI number",
					"type": "string"
				},
				"senderId": {
					"description": "The external id for the RFI.",
					"type": "string"
				},
				"reasons": {
					"description": "The list of keywords either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"dueDate": {
					"format": "DateTime",
					"description": "The date a response must be sent back for the RFI\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"disciplines": {
					"description": "The list of disciplines either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"keywords": {
					"description": "The list of keywords either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"suggestion": {
					"description": "The suggestion passed with the RFI",
					"type": "string"
				},
				"internalNotes": {
					"description": "Internal notes of the RFI",
					"type": "string"
				},
				"contractId": {
					"format": "uuid",
					"description": "The contract associated with RFI",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"rfiId": {
					"format": "uuid",
					"description": "Id RFI would have after creation",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"reminder": {
					"format": "int64",
					"description": "Number of day before due date to send a reminder",
					"maximum": 365,
					"minimum": 0,
					"type": "integer"
				},
				"attachments": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/WorkflowActionUploadFileDto"
					}
				}
			}
		},
		"DeleteFolderPartsRequestDTO": {
			"required": [
				"folderParts"
			],
			"type": "object",
			"properties": {
				"folderParts": {
					"type": "array",
					"items": {
						"type": "string"
					}
				}
			}
		},
		"RfiSubmitResponseRequestDTO": {
			"required": [
				"version",
				"response",
				"subject",
				"from",
				"to",
				"receivedDate",
				"via"
			],
			"type": "object",
			"properties": {
				"version": {
					"description": "The current version of Rfi for concurrency check",
					"type": "string"
				},
				"response": {
					"$ref": "#/definitions/KeywordDto[ProjectItemActionType]",
					"description": "Action type for the Rfi"
				},
				"subject": {
					"description": "Rfi subject",
					"type": "string"
				},
				"remarks": {
					"description": "The remarks for the Rfi",
					"type": "string"
				},
				"from": {
					"$ref": "#/definitions/IAssignedTo",
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>"
				},
				"to": {
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"cc": {
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"receivedDate": {
					"format": "DateTime",
					"description": "The date the original review was received\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"via": {
					"$ref": "#/definitions/KeywordDto[TransferMethodKeyword]",
					"description": "Method with which Rfi was received"
				},
				"keywords": {
					"description": "The list of keywords either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"attachments": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/WorkflowActionUploadFileDto"
					}
				}
			}
		},
		"RfiCompleteSubmitResponseRequestDTO": {
			"required": [
				"version",
				"response",
				"subject",
				"from",
				"to",
				"receivedDate",
				"via"
			],
			"type": "object",
			"properties": {
				"folderParts": {
					"description": "Array of folder parts with location to save attachment files",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"lockId": {
					"description": "Project Item Lock identifier",
					"type": "string"
				},
				"version": {
					"description": "The current version of Rfi for concurrency check",
					"type": "string"
				},
				"response": {
					"$ref": "#/definitions/KeywordDto[ProjectItemActionType]",
					"description": "Action type for the Rfi"
				},
				"subject": {
					"description": "Rfi subject",
					"type": "string"
				},
				"remarks": {
					"description": "The remarks for the Rfi",
					"type": "string"
				},
				"from": {
					"$ref": "#/definitions/IAssignedTo",
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>"
				},
				"to": {
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"cc": {
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"receivedDate": {
					"format": "DateTime",
					"description": "The date the original review was received\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"via": {
					"$ref": "#/definitions/KeywordDto[TransferMethodKeyword]",
					"description": "Method with which Rfi was received"
				},
				"keywords": {
					"description": "The list of keywords either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"attachments": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/WorkflowActionUploadFileDto"
					}
				}
			}
		},
		"DeleteWorkflowActionRequestDTO": {
			"required": [
				"lockId",
				"folderParts"
			],
			"type": "object",
			"properties": {
				"lockId": {
					"type": "string"
				},
				"folderParts": {
					"type": "array",
					"items": {
						"type": "string"
					}
				}
			}
		},
		"PagedResponseDto[SubmittalListDTO]": {
			"type": "object",
			"properties": {
				"items": {
					"description": "The filtered list of items requested",
					"type": "array",
					"items": {
						"$ref": "#/definitions/SubmittalListDTO"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"SubmittalListDTO": {
			"type": "object",
			"properties": {
				"id": {
					"format": "uuid",
					"description": "The GUID of the project item",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"subject": {
					"description": "The subject of the project item (plain text)",
					"type": "string"
				},
				"number": {
					"description": "The Submittal number (ID)",
					"type": "string"
				},
				"projectId": {
					"format": "uuid",
					"description": "The id of the project (ID)",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"specSection": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "MasterFormat™ specification section number, limited to the UAC Submittal Spec Section List for its project"
				},
				"dueDate": {
					"format": "DateTime",
					"description": "The date when the anticipated incoming submittal is (or was) due to arrive.\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[WorkflowActionStatus]",
					"description": "The workflow status from the UAC [PROJECT_ITEM_TYPE] Workflow Status for its project, e.g., \"Expected\", \"Open\""
				},
				"disciplines": {
					"description": "The list of disciplines either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"lockId": {
					"description": "Lock id (if exists) that indicated that submittal has an action in-progress",
					"type": "string"
				}
			}
		},
		"SubmittalsGroupingResponse": {
			"type": "object",
			"properties": {
				"pending": {
					"description": "The list of submittals with status: pending",
					"type": "array",
					"items": {
						"$ref": "#/definitions/PendingSubmittalDTO"
					}
				},
				"open": {
					"description": "The list of submittals with status: open",
					"type": "array",
					"items": {
						"$ref": "#/definitions/OpenSubmittalDTO"
					}
				},
				"forwarded": {
					"description": "The list of submittals with status: forwarded",
					"type": "array",
					"items": {
						"$ref": "#/definitions/ForwardedSubmittalDTO"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"PendingSubmittalDTO": {
			"type": "object",
			"properties": {
				"id": {
					"format": "uuid",
					"description": "The GUID of the project item",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"subject": {
					"description": "The subject of the project item (plain text)",
					"type": "string"
				},
				"number": {
					"description": "The Submittal number (ID)",
					"type": "string"
				},
				"projectId": {
					"format": "uuid",
					"description": "The id of the project (ID)",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"specSection": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "MasterFormat™ specification section number, limited to the UAC Submittal Spec Section List for its project"
				},
				"dueDate": {
					"format": "DateTime",
					"description": "The date when the anticipated incoming submittal is (or was) due to arrive.\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[WorkflowActionStatus]",
					"description": "The workflow status from the UAC [PROJECT_ITEM_TYPE] Workflow Status for its project, e.g., \"Expected\", \"Open\""
				},
				"disciplines": {
					"description": "The list of disciplines either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"lockId": {
					"description": "Lock id (if exists) that indicated that submittal has an action in-progress",
					"type": "string"
				}
			}
		},
		"OpenSubmittalDTO": {
			"type": "object",
			"properties": {
				"id": {
					"format": "uuid",
					"description": "The GUID of the project item",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"subject": {
					"description": "The subject of the project item (plain text)",
					"type": "string"
				},
				"number": {
					"description": "The Submittal number (ID)",
					"type": "string"
				},
				"projectId": {
					"format": "uuid",
					"description": "The id of the project (ID)",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"specSection": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "MasterFormat™ specification section number, limited to the UAC Submittal Spec Section List for its project"
				},
				"dueDate": {
					"format": "DateTime",
					"description": "The date when the anticipated incoming submittal is (or was) due to arrive.\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[WorkflowActionStatus]",
					"description": "The workflow status from the UAC [PROJECT_ITEM_TYPE] Workflow Status for its project, e.g., \"Expected\", \"Open\""
				},
				"allReviewsRecorded": {
					"description": "Indicates if all reviews have a recorded response",
					"type": "boolean"
				},
				"disciplines": {
					"description": "The list of disciplines either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"lockId": {
					"description": "Lock id (if exists) that indicated that submittal has an action in-progress",
					"type": "string"
				}
			}
		},
		"ForwardedSubmittalDTO": {
			"type": "object",
			"properties": {
				"id": {
					"format": "uuid",
					"description": "The GUID of the project item",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"subject": {
					"description": "The subject of the project item (plain text)",
					"type": "string"
				},
				"number": {
					"description": "The Submittal number (ID)",
					"type": "string"
				},
				"projectId": {
					"format": "uuid",
					"description": "The id of the project (ID)",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"specSection": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "MasterFormat™ specification section number, limited to the UAC Submittal Spec Section List for its project"
				},
				"dueDate": {
					"format": "DateTime",
					"description": "The date when the anticipated incoming submittal is (or was) due to arrive.\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"reviewDueDate": {
					"format": "DateTime",
					"description": "The earliest review due date when the response for submittal is anticipated\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\".",
					"type": "DateTime",
					"readOnly": true,
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[WorkflowActionStatus]",
					"description": "The workflow status from the UAC [PROJECT_ITEM_TYPE] Workflow Status for its project, e.g., \"Expected\", \"Open\""
				},
				"forwardedReviews": {
					"description": "The list of reviews for forwarded submittals",
					"type": "array",
					"items": {
						"$ref": "#/definitions/ForwardedReviewDTO"
					}
				},
				"disciplines": {
					"description": "The list of disciplines either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"lockId": {
					"description": "Lock id (if exists) that indicated that submittal has an action in-progress",
					"type": "string"
				}
			}
		},
		"SubmittalUpdatedDetailsDto": {
			"description": "Object representation of JSON value used in Submittal Details Update endpoint.\r\nUses Option types to notify if value was passed in JSON and what it is.",
			"required": [
				"version"
			],
			"type": "object",
			"properties": {
				"version": {
					"description": "Represents current version of submittal, that will be compared to DB value while updating.",
					"type": "string"
				},
				"subject": {
					"$ref": "#/definitions/Option[String]",
					"description": "Submittal subject. \r\nIf this property is null it won't be updated in DB, otherwise it's value will be used to update the DB."
				},
				"number": {
					"$ref": "#/definitions/Option[String]",
					"description": "Submittal ID / Number.\r\nIf this property is null it won't be updated in DB, otherwise it's value will be used to update the DB."
				},
				"specSection": {
					"$ref": "#/definitions/Option[KeywordDto[GenericKeyword]]",
					"description": "Submittal Spec Section.\r\nIf this property is null it won't be updated in DB, otherwise it's value will be used to update the DB."
				},
				"dueDate": {
					"$ref": "#/definitions/Option[Nullable[DateTime]]",
					"description": "Submittal Due Date.\r\nIf this property is null it won't be updated in DB, otherwise it's value will be used to update the DB."
				},
				"receivedDate": {
					"$ref": "#/definitions/Option[Nullable[DateTime]]",
					"description": "Submittal Received Date.\r\nIf this property is null it won't be updated in DB, otherwise it's value will be used to update the DB."
				},
				"senderId": {
					"$ref": "#/definitions/Option[String]",
					"description": "Submittal Sender Id.\r\nIf this property is null it won't be updated in DB, otherwise it's value will be used to update the DB."
				},
				"from": {
					"$ref": "#/definitions/Option[IAssignedTo]",
					"description": "Submittal From contact.\r\nIf this property is null it won't be updated in DB, otherwise it's value will be used to update the DB."
				},
				"to": {
					"$ref": "#/definitions/Option[IAssignedTo[]]",
					"description": "Submittal To contact(s).\r\nIf this property is null it won't be updated in DB, otherwise it's value will be used to update the DB."
				},
				"keywords": {
					"$ref": "#/definitions/Option[IEnumerable[KeywordDto[GenericKeyword]]]",
					"description": "Submittal keyword(s).\r\nIf this property is null it won't be updated in DB, otherwise it's value will be used to update the DB."
				},
				"disciplines": {
					"$ref": "#/definitions/Option[IEnumerable[KeywordDto[GenericKeyword]]]",
					"description": "Submittal discipline(s).\r\nIf this property is null it won't be updated in DB, otherwise it's value will be used to update the DB."
				},
				"description": {
					"$ref": "#/definitions/Option[String]",
					"description": "Submittal remarks.\r\nIf this property is null it won't be updated in DB, otherwise it's value will be used to update the DB."
				},
				"internalNotes": {
					"$ref": "#/definitions/Option[String]",
					"description": "Submittal Internal Notes.\r\nIf this property is null it won't be updated in DB, otherwise it's value will be used to update the DB."
				}
			}
		},
		"Option[String]": {
			"description": "Object to represent optional value from converting JSON, to correctly keep information about null values.",
			"type": "object",
			"properties": {
				"Value": {
					"description": "Actual value hold by the object",
					"type": "string"
				}
			}
		},
		"Option[KeywordDto[GenericKeyword]]": {
			"description": "Object to represent optional value from converting JSON, to correctly keep information about null values.",
			"type": "object",
			"properties": {
				"Value": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "Actual value hold by the object"
				}
			}
		},
		"Option[Nullable[DateTime]]": {
			"description": "Object to represent optional value from converting JSON, to correctly keep information about null values.",
			"type": "object",
			"properties": {
				"Value": {
					"format": "DateTime",
					"description": "Actual value hold by the object",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				}
			}
		},
		"Option[IAssignedTo]": {
			"description": "Object to represent optional value from converting JSON, to correctly keep information about null values.",
			"type": "object",
			"properties": {
				"Value": {
					"$ref": "#/definitions/IAssignedTo",
					"description": "Actual value hold by the object"
				}
			}
		},
		"Option[IAssignedTo[]]": {
			"description": "Object to represent optional value from converting JSON, to correctly keep information about null values.",
			"type": "object",
			"properties": {
				"Value": {
					"description": "Actual value hold by the object",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				}
			}
		},
		"Option[IEnumerable[KeywordDto[GenericKeyword]]]": {
			"description": "Object to represent optional value from converting JSON, to correctly keep information about null values.",
			"type": "object",
			"properties": {
				"Value": {
					"description": "Actual value hold by the object",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				}
			}
		},
		"SubmittalDetailsDto": {
			"type": "object",
			"properties": {
				"id": {
					"format": "uuid",
					"description": "Submittal id",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"number": {
					"description": "The internal reference number for the submittal",
					"type": "string"
				},
				"subject": {
					"description": "The subject of the submittal",
					"type": "string"
				},
				"project": {
					"$ref": "#/definitions/ProjectDto",
					"description": "The details of the project, the submittal is associated with"
				},
				"specSection": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "The spec section that the submittal relates to."
				},
				"dueDate": {
					"format": "DateTime",
					"description": "The date a response must be sent back for the submittal\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"receivedDate": {
					"format": "DateTime",
					"description": "The date the original review was received\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"senderId": {
					"description": "The external id for the submittal.",
					"type": "string"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[WorkflowActionStatus]",
					"description": "The workflow status from the UAC [PROJECT_ITEM_TYPE] Workflow Status for its project, e.g., \"Expected\", \"Open\""
				},
				"from": {
					"$ref": "#/definitions/ContactDTO",
					"description": "The sender of the original review"
				},
				"to": {
					"description": "The recipient of the original review",
					"type": "array",
					"items": {
						"$ref": "#/definitions/ContactDTO"
					}
				},
				"version": {
					"description": "Version number for use in optimistic concurrency check when modifying submittal",
					"type": "string"
				},
				"keywords": {
					"description": "The list of keywords either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"disciplines": {
					"description": "The list of disciplines either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"description": {
					"description": "The description of the submittal",
					"type": "string"
				},
				"internalNotes": {
					"description": "Internal notes of the submittal",
					"type": "string"
				},
				"filesCount": {
					"format": "int32",
					"description": "Number of associated files",
					"type": "integer"
				},
				"mostRecentWorkflowAction": {
					"$ref": "#/definitions/WorkflowActionDto",
					"description": "Most recent workflow action"
				},
				"workflowActionsCount": {
					"format": "int32",
					"description": "Number of workflow actions",
					"type": "integer"
				},
				"lockId": {
					"description": "Lock id (if exists) that indicated that submittal has an action in-progress",
					"type": "string"
				}
			}
		},
		"PagedResponseDto[WorkflowActionFileDto]": {
			"type": "object",
			"properties": {
				"items": {
					"description": "The filtered list of items requested",
					"type": "array",
					"items": {
						"$ref": "#/definitions/WorkflowActionFileDto"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"WorkflowActionFileDto": {
			"type": "object",
			"properties": {
				"file": {
					"$ref": "#/definitions/WorkflowActionExistingFileDto"
				},
				"workflowAction": {
					"$ref": "#/definitions/WorkflowActionDateTypeDto"
				}
			}
		},
		"WorkflowActionDateTypeDto": {
			"type": "object",
			"properties": {
				"actionType": {
					"$ref": "#/definitions/KeywordDto[WorkflowCompletedActionType]"
				},
				"actionDate": {
					"format": "DateTime",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				}
			}
		},
		"SubmittalInfoAndActions": {
			"type": "object",
			"properties": {
				"lockId": {
					"description": "Lock id (if exists) that indicated that submittal has an action in-progress",
					"type": "string"
				},
				"items": {
					"description": "The filtered list of items requested",
					"type": "array",
					"items": {
						"$ref": "#/definitions/WorkflowActionDto"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"SubmittalForwardRequestDTO": {
			"required": [
				"version",
				"purpose",
				"to",
				"via"
			],
			"type": "object",
			"properties": {
				"version": {
					"description": "The current version of submittal for concurrency check",
					"type": "string"
				},
				"purpose": {
					"$ref": "#/definitions/KeywordDto[ProjectItemActionType]",
					"description": "Action type for the submittal"
				},
				"to": {
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"via": {
					"description": "Method with which submittal was forwarded",
					"pattern": "info-exchange",
					"type": "string"
				},
				"reviewDueDate": {
					"format": "DateTime",
					"description": "Format is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"sentDate": {
					"format": "DateTime",
					"description": "Format is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"cc": {
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"remarks": {
					"description": "The description of the submittal",
					"type": "string"
				},
				"attachments": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/WorkflowActionUploadFileDto"
					}
				}
			}
		},
		"SubmittalCompleteForwardRequestDTO": {
			"required": [
				"version",
				"purpose",
				"to",
				"via"
			],
			"type": "object",
			"properties": {
				"folderParts": {
					"description": "Array of folder parts with location to save attachment files",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"lockId": {
					"description": "Project Item Lock identifier",
					"type": "string"
				},
				"version": {
					"description": "The current version of submittal for concurrency check",
					"type": "string"
				},
				"purpose": {
					"$ref": "#/definitions/KeywordDto[ProjectItemActionType]",
					"description": "Action type for the submittal"
				},
				"to": {
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"via": {
					"description": "Method with which submittal was forwarded",
					"pattern": "info-exchange",
					"type": "string"
				},
				"reviewDueDate": {
					"format": "DateTime",
					"description": "Format is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"sentDate": {
					"format": "DateTime",
					"description": "Format is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"cc": {
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"remarks": {
					"description": "The description of the submittal",
					"type": "string"
				},
				"attachments": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/WorkflowActionUploadFileDto"
					}
				}
			}
		},
		"SubmittalReceiveRequestDTO": {
			"required": [
				"version",
				"purpose",
				"specSection",
				"submittalNumber",
				"from",
				"to",
				"receivedDate"
			],
			"type": "object",
			"properties": {
				"version": {
					"description": "The current version of submittal for concurrency check",
					"type": "string"
				},
				"purpose": {
					"$ref": "#/definitions/KeywordDto[ProjectItemActionType]",
					"description": "Action type for the submittal"
				},
				"senderId": {
					"description": "The external id for the submittal.",
					"type": "string"
				},
				"specSection": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "The spec section that the submittal relates to."
				},
				"submittalNumber": {
					"description": "Unique submittal number",
					"type": "string"
				},
				"from": {
					"$ref": "#/definitions/IAssignedTo",
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>"
				},
				"to": {
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"receivedDate": {
					"format": "DateTime",
					"description": "Format is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"dueDate": {
					"format": "DateTime",
					"description": "Format is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"attachments": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/WorkflowActionUploadFileDto"
					}
				}
			}
		},
		"SubmittalCompleteReceiveRequestDTO": {
			"required": [
				"version",
				"purpose",
				"specSection",
				"submittalNumber",
				"from",
				"to",
				"receivedDate"
			],
			"type": "object",
			"properties": {
				"folderParts": {
					"description": "Array of folder parts with location to save attachment files",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"lockId": {
					"description": "Project Item Lock identifier",
					"type": "string"
				},
				"version": {
					"description": "The current version of submittal for concurrency check",
					"type": "string"
				},
				"purpose": {
					"$ref": "#/definitions/KeywordDto[ProjectItemActionType]",
					"description": "Action type for the submittal"
				},
				"senderId": {
					"description": "The external id for the submittal.",
					"type": "string"
				},
				"specSection": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "The spec section that the submittal relates to."
				},
				"submittalNumber": {
					"description": "Unique submittal number",
					"type": "string"
				},
				"from": {
					"$ref": "#/definitions/IAssignedTo",
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>"
				},
				"to": {
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"receivedDate": {
					"format": "DateTime",
					"description": "Format is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"dueDate": {
					"format": "DateTime",
					"description": "Format is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"attachments": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/WorkflowActionUploadFileDto"
					}
				}
			}
		},
		"SubmittalLogRequestDTO": {
			"required": [
				"from",
				"to",
				"purpose",
				"subject",
				"receivedDate",
				"via"
			],
			"type": "object",
			"properties": {
				"from": {
					"$ref": "#/definitions/IAssignedTo",
					"description": "The sender of the original review\r\n<para>Description of availalbe types for IAssignedTo elements:</para><para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para><para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>"
				},
				"to": {
					"description": "The recipient of the original review\r\n<para>Description of availalbe types for IAssignedTo elements:</para><para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para><para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"purpose": {
					"$ref": "#/definitions/KeywordDto[ProjectItemActionType]",
					"description": "Action type for the submittal"
				},
				"description": {
					"description": "The description of the submittal",
					"type": "string"
				},
				"senderId": {
					"description": "The external id for the submittal.",
					"type": "string"
				},
				"internalNotes": {
					"description": "Internal notes of the submittal",
					"type": "string"
				},
				"specSection": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "The spec section that the submittal relates to."
				},
				"submittalNumber": {
					"description": "Unique submittal number",
					"type": "string"
				},
				"subject": {
					"description": "Submittal subject",
					"type": "string"
				},
				"dueDate": {
					"format": "DateTime",
					"description": "The date a response must be sent back for the submittal\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"receivedDate": {
					"format": "DateTime",
					"description": "The date the original review was received\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"keywords": {
					"description": "The list of keywords either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"disciplines": {
					"description": "The list of disciplines either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"via": {
					"$ref": "#/definitions/KeywordDto[TransferMethodKeyword]",
					"description": "Method with which submittal was received"
				},
				"submittalId": {
					"format": "uuid",
					"description": "Id Submittal would have after creation",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"reminder": {
					"format": "int64",
					"description": "Number of day before due date to send a reminder",
					"maximum": 365,
					"minimum": 0,
					"type": "integer"
				},
				"attachments": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/WorkflowActionUploadFileDto"
					}
				}
			}
		},
		"SubmittalCompleteLogRequestDTO": {
			"required": [
				"from",
				"to",
				"purpose",
				"subject",
				"receivedDate",
				"via"
			],
			"type": "object",
			"properties": {
				"folderParts": {
					"description": "Array of folder parts with location to save attachment files",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"lockId": {
					"description": "Project Item Lock identifier",
					"type": "string"
				},
				"from": {
					"$ref": "#/definitions/IAssignedTo",
					"description": "The sender of the original review\r\n<para>Description of availalbe types for IAssignedTo elements:</para><para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para><para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>"
				},
				"to": {
					"description": "The recipient of the original review\r\n<para>Description of availalbe types for IAssignedTo elements:</para><para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para><para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para><para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"purpose": {
					"$ref": "#/definitions/KeywordDto[ProjectItemActionType]",
					"description": "Action type for the submittal"
				},
				"description": {
					"description": "The description of the submittal",
					"type": "string"
				},
				"senderId": {
					"description": "The external id for the submittal.",
					"type": "string"
				},
				"internalNotes": {
					"description": "Internal notes of the submittal",
					"type": "string"
				},
				"specSection": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "The spec section that the submittal relates to."
				},
				"submittalNumber": {
					"description": "Unique submittal number",
					"type": "string"
				},
				"subject": {
					"description": "Submittal subject",
					"type": "string"
				},
				"dueDate": {
					"format": "DateTime",
					"description": "The date a response must be sent back for the submittal\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"receivedDate": {
					"format": "DateTime",
					"description": "The date the original review was received\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"keywords": {
					"description": "The list of keywords either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"disciplines": {
					"description": "The list of disciplines either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"via": {
					"$ref": "#/definitions/KeywordDto[TransferMethodKeyword]",
					"description": "Method with which submittal was received"
				},
				"submittalId": {
					"format": "uuid",
					"description": "Id Submittal would have after creation",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"reminder": {
					"format": "int64",
					"description": "Number of day before due date to send a reminder",
					"maximum": 365,
					"minimum": 0,
					"type": "integer"
				},
				"attachments": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/WorkflowActionUploadFileDto"
					}
				}
			}
		},
		"SubmittalSubmitResponseRequestDTO": {
			"required": [
				"version",
				"response",
				"subject",
				"from",
				"to",
				"receivedDate",
				"via"
			],
			"type": "object",
			"properties": {
				"version": {
					"description": "The current version of submittal for concurrency check",
					"type": "string"
				},
				"response": {
					"$ref": "#/definitions/KeywordDto[ProjectItemActionType]",
					"description": "Action type for the submittal"
				},
				"subject": {
					"description": "Submittal subject",
					"type": "string"
				},
				"remarks": {
					"description": "The description of the submittal",
					"type": "string"
				},
				"from": {
					"$ref": "#/definitions/IAssignedTo",
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>"
				},
				"to": {
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"cc": {
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"receivedDate": {
					"format": "DateTime",
					"description": "The date the original review was received\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"via": {
					"$ref": "#/definitions/KeywordDto[TransferMethodKeyword]",
					"description": "Method with which submittal was received"
				},
				"keywords": {
					"description": "The list of keywords either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"attachments": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/WorkflowActionUploadFileDto"
					}
				}
			}
		},
		"SubmittalCompleteSubmitResponseRequestDTO": {
			"required": [
				"version",
				"response",
				"subject",
				"from",
				"to",
				"receivedDate",
				"via"
			],
			"type": "object",
			"properties": {
				"folderParts": {
					"description": "Array of folder parts with location to save attachment files",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"lockId": {
					"description": "Project Item Lock identifier",
					"type": "string"
				},
				"version": {
					"description": "The current version of submittal for concurrency check",
					"type": "string"
				},
				"response": {
					"$ref": "#/definitions/KeywordDto[ProjectItemActionType]",
					"description": "Action type for the submittal"
				},
				"subject": {
					"description": "Submittal subject",
					"type": "string"
				},
				"remarks": {
					"description": "The description of the submittal",
					"type": "string"
				},
				"from": {
					"$ref": "#/definitions/IAssignedTo",
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>"
				},
				"to": {
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"cc": {
					"description": "<para>Description of availalbe types for IAssignedTo elements:</para>\r\n<para>adHoc - when contact doesn't exist in the system and need to be added: { \"name\": \"adHocContact\", \"email\": \"john.doe@email.com\" }</para>\r\n<para>projectMember - when contact is assigned to a project: { \"name\": \"projectTeamMember\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>projectTeamMemberGroup - when project team members are assigned to a group in the project: { \"name\": \"projectTeamMemberGroup\", \"id\": \"59e07;054eb07f-d7cb-464c-9a3f-2efaec26e6f3;43135935-043b-4db0-ab38-6a60c999922b\" }</para>\r\n<para>contact -  it's an underlying base information for projectTeamMember: { \"name\": \"contact\", \"id\": \"43135935-043b-4db0-ab38-6a60c999922b\" }</para>",
					"type": "array",
					"items": {
						"$ref": "#/definitions/IAssignedTo"
					}
				},
				"receivedDate": {
					"format": "DateTime",
					"description": "The date the original review was received\r\nFormat is ISO 8601, that is, \"YYYY-MM-DDThh:mm:ssZ\" | \"YYYY-MM-DDThh:mm:ss.sssZ\" | \"YYYY-MM-DDThh:mm:ss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss-hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss+hh:mm\" | \"YYYY-MM-DDThh:mm:ss.sss-hh:mm\".",
					"type": "DateTime",
					"example": "2022-12-20T11:33:23Z OR 2022-12-20T11:33:23.123Z OR 2022-12-20T11:33:23+01:00 OR 2022-12-20T11:33:23.123+01:00"
				},
				"via": {
					"$ref": "#/definitions/KeywordDto[TransferMethodKeyword]",
					"description": "Method with which submittal was received"
				},
				"keywords": {
					"description": "The list of keywords either from predefined list in NPC or user entered",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"attachments": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/WorkflowActionUploadFileDto"
					}
				}
			}
		},
		"V1SearchRequestDto": {
			"required": [
				"query"
			],
			"type": "object",
			"properties": {
				"query": {
					"description": "The search phrase",
					"type": "string"
				},
				"extensions": {
					"description": "Array of file extensions (without '.') to search.",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"projects": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/SearchProjectDto"
					}
				},
				"requestedProperties": {
					"type": "array",
					"items": {
						"enum": [
							"cts_key",
							"file_key",
							"cross_reference",
							"reference",
							"entry_path",
							"filter_result",
							"filter_reason",
							"filter_time",
							"filter_timespan",
							"image_application_name",
							"image_author",
							"image_camera_manufacturer",
							"image_camera_model",
							"image_comment",
							"image_copyright",
							"image_date_taken",
							"image_format",
							"image_keywords",
							"image_location",
							"image_rating",
							"image_subject",
							"image_title",
							"image_pixel_dimensions",
							"image_bits_per_pixel",
							"edms_plugin_config_id",
							"edms_provider_id",
							"file_directory",
							"file_name",
							"file_path",
							"file_size",
							"file_system_attributes",
							"file_write_time",
							"file_create_time",
							"file_content"
						],
						"type": "string"
					}
				},
				"previewPrefix": {
					"type": "string"
				},
				"previewSuffix": {
					"type": "string"
				},
				"resultsLimitType": {
					"enum": [
						"default",
						"none",
						"user_specified"
					],
					"type": "string"
				},
				"resultsLimit": {
					"format": "int32",
					"type": "integer"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				}
			}
		},
		"SearchProjectDto": {
			"type": "object",
			"properties": {
				"id": {
					"type": "string"
				},
				"folders": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/EDMSObjectIdDto"
					}
				}
			}
		},
		"PagedResponseDto[FileResult]": {
			"type": "object",
			"properties": {
				"items": {
					"description": "The filtered list of items requested",
					"type": "array",
					"items": {
						"$ref": "#/definitions/FileResult"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"FileResult": {
			"type": "object",
			"properties": {
				"Properties": {
					"type": "array",
					"items": {
						"type": "object"
					}
				},
				"Previews": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/PreviewElement"
					}
				}
			}
		},
		"PreviewElement": {
			"type": "object",
			"properties": {
				"Property": {
					"$ref": "#/definitions/Property"
				},
				"Preview": {
					"type": "string"
				}
			}
		},
		"Property": {
			"type": "object",
			"properties": {
				"_propertySet": {
					"format": "uuid",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"_propertyIDNum": {
					"format": "int32",
					"type": "integer"
				},
				"_propertyIDStr": {
					"type": "string"
				}
			}
		},
		"PagedResponseDto[SearchResponseDto]": {
			"type": "object",
			"properties": {
				"items": {
					"description": "The filtered list of items requested",
					"type": "array",
					"items": {
						"$ref": "#/definitions/SearchResponseDto"
					}
				},
				"offsetToken": {
					"description": "The token to supply in the next request to retrieve the next page of items",
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"description": "The number of items remaining that can be requested. 0 means there are no more items",
					"type": "integer"
				}
			}
		},
		"SearchResponseDto": {
			"type": "object",
			"properties": {
				"previews": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/PropertyPreviewPair"
					}
				},
				"properties": {
					"type": "object",
					"properties": {
						"cts_key": {
							"type": "object"
						},
						"file_key": {
							"type": "object"
						},
						"cross_reference": {
							"type": "object"
						},
						"reference": {
							"type": "object"
						},
						"entry_path": {
							"type": "object"
						},
						"filter_result": {
							"type": "object"
						},
						"filter_reason": {
							"type": "object"
						},
						"filter_time": {
							"type": "object"
						},
						"filter_timespan": {
							"type": "object"
						},
						"image_application_name": {
							"type": "object"
						},
						"image_author": {
							"type": "object"
						},
						"image_camera_manufacturer": {
							"type": "object"
						},
						"image_camera_model": {
							"type": "object"
						},
						"image_comment": {
							"type": "object"
						},
						"image_copyright": {
							"type": "object"
						},
						"image_date_taken": {
							"type": "object"
						},
						"image_format": {
							"type": "object"
						},
						"image_keywords": {
							"type": "object"
						},
						"image_location": {
							"type": "object"
						},
						"image_rating": {
							"type": "object"
						},
						"image_subject": {
							"type": "object"
						},
						"image_title": {
							"type": "object"
						},
						"image_pixel_dimensions": {
							"type": "object"
						},
						"image_bits_per_pixel": {
							"type": "object"
						},
						"edms_plugin_config_id": {
							"type": "object"
						},
						"edms_provider_id": {
							"type": "object"
						},
						"file_directory": {
							"type": "object"
						},
						"file_name": {
							"type": "object"
						},
						"file_path": {
							"type": "object"
						},
						"file_size": {
							"type": "object"
						},
						"file_system_attributes": {
							"type": "object"
						},
						"file_write_time": {
							"type": "object"
						},
						"file_create_time": {
							"type": "object"
						},
						"file_content": {
							"type": "object"
						}
					}
				}
			}
		},
		"PropertyPreviewPair": {
			"type": "object",
			"properties": {
				"property": {
					"enum": [
						"cts_key",
						"file_key",
						"cross_reference",
						"reference",
						"entry_path",
						"filter_result",
						"filter_reason",
						"filter_time",
						"filter_timespan",
						"image_application_name",
						"image_author",
						"image_camera_manufacturer",
						"image_camera_model",
						"image_comment",
						"image_copyright",
						"image_date_taken",
						"image_format",
						"image_keywords",
						"image_location",
						"image_rating",
						"image_subject",
						"image_title",
						"image_pixel_dimensions",
						"image_bits_per_pixel",
						"edms_plugin_config_id",
						"edms_provider_id",
						"file_directory",
						"file_name",
						"file_path",
						"file_size",
						"file_system_attributes",
						"file_write_time",
						"file_create_time",
						"file_content"
					],
					"type": "string"
				},
				"preview": {
					"type": "string"
				}
			}
		},
		"NewformaVersionInfo": {
			"type": "object",
			"properties": {
				"NewformaLinkVersion": {
					"type": "string"
				},
				"NewformaLinkCompatibilityNumber": {
					"type": "string"
				},
				"NPCSVersion": {
					"type": "string"
				},
				"NPCSCompatibilityNumber": {
					"type": "string"
				},
				"CoreVersion": {
					"type": "string"
				},
				"APIVersion": {
					"type": "string"
				},
				"CustomerId": {
					"type": "string"
				},
				"MachineName": {
					"type": "string"
				},
				"ErpApiEnabled": {
					"type": "string"
				}
			}
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/ReferenceNL/NewformaLink040323.json
 ** module id = 1386
 ** module chunks = 0
 **/